import {
  CLICKS,
  CPA,
  CTR,
  IMPRESSIONS,
  RESULTS,
  SPEND,
  ALL_CONVERSIONS,
  ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  ALL_CONVERSIONS_VALUE,
  AVERAGE_CART_SIZE,
  AVERAGE_COST,
  AVERAGE_CPC,
  AVERAGE_ORDER_VALUE_MICROS,
  CONVERSIONS_FROM_INTERACTIONS_RATE,
  CONVERSIONS_VALUE,
  COST_OF_GOODS_SOLD_MICROS,
  COST_PER_ALL_CONVERSIONS,
  COST_PER_APP_EVENT_ADD_TO_CART,
  COST_PER_APP_INSTALL,
  COST_PER_CHECKOUT,
  COST_PER_CONVERSION,
  COST_PER_PURCHASE,
  COST_PER_VIEW_CONTENT,
  CROSS_DEVICE_CONVERSIONS,
  CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  CROSS_SELL_GROSS_PROFIT_MICROS,
  CROSS_SELL_REVENUE_MICROS,
  CROSS_SELL_UNITS_SOLD,
  GROSS_PROFIT_MARGIN,
  GROSS_PROFIT_MICROS,
  INTERACTION_RATE,
  INTERACTIONS_METRICS,
  LEAD_COST_OF_GOODS_SOLD_MICROS,
  LEAD_GROSS_PROFIT_MICROS,
  LEAD_REVENUE_MICROS,
  LEAD_UNITS_SOLD,
  ORDERS_METRICS,
  REVENUE_MICROS,
  VALUE_PER_ALL_CONVERSIONS,
  VALUE_PER_CONVERSION,
  VIEW_THROUGH_CONVERSIONS,
  ACTION_VALUES,
  ACTIONS_METRICS,
  AD_CLICK_ACTIONS,
  AD_IMPRESSION_ACTIONS,
  AUCTION_BID,
  AUCTION_COMPETITIVENESS,
  AUCTION_MAX_COMPETITOR_BID,
  CANVAS_AVG_VIEW_PERCENT,
  CANVAS_AVG_VIEW_TIME,
  CATALOG_SEGMENT_ACTIONS,
  CATALOG_SEGMENT_VALUE,
  CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  CONVERSION_VALUES,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PRODUCT_QUANTITY,
  CONVERTED_PRODUCT_VALUE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  CONVERTED_PROMOTED_PRODUCT_VALUE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  COST_PER_15SEC_VIDEO_VIEW,
  COST_PER_15_SEC_VIDEO_VIEW,
  COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  COST_PER_ACTION_TYPE,
  COST_PER_AD_CLICK,
  COST_PER_DDA_COUNT_BY_CONVS,
  COST_PER_ESTIMATED_AD_RECALLERS,
  COST_PER_INLINE_LINK_CLICK,
  COST_PER_INLINE_POST_ENGAGEMENT,
  COST_PER_OBJECTIVE_RESULT,
  COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  COST_PER_OUTBOUND_CLICK,
  COST_PER_RESULT,
  COST_PER_THRUPLAY,
  COST_PER_UNIQUE_ACTION_TYPE,
  COST_PER_UNIQUE_CLICK,
  COST_PER_UNIQUE_CONVERSION,
  COST_PER_UNIQUE_INLINE_LINK_CLICK,
  COST_PER_UNIQUE_OUTBOUND_CLICK,
  CPP,
  DDA_COUNT_BY_CONVS,
  DDA_RESULTS,
  ESTIMATED_AD_RECALLERS,
  INSTAGRAM_PROFILE_FOLLOW,
  FULL_VIEW_IMPRESSIONS,
  FULL_VIEW_REACH,
  INLINE_LINK_CLICK_CTR,
  INLINE_LINK_CLICKS,
  INLINE_POST_ENGAGEMENT,
  INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  INSTANT_EXPERIENCE_CLICKS_TO_START,
  INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  INTERACTIVE_COMPONENT_TAP,
  LANDING_PAGE_VIEW_PER_LINK_CLICK,
  MARKETING_MESSAGES_DELIVERY_RATE,
  OBJECTIVE_RESULT_RATE,
  OBJECTIVE_RESULTS,
  OUTBOUND_CLICKS,
  OUTBOUND_CLICKS_CTR,
  PURCHASE_PER_LANDING_PAGE_VIEW,
  QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  RESULT_RATE,
  RESULTS_METRICS,
  ROAS_METRICS,
  SHOPS_ASSISTED_PURCHASES,
  SOCIAL_SPEND,
  TOTAL_CARD_VIEW,
  VIDEO_30_SEC_WATCHED_ACTIONS,
  VIDEO_AVG_TIME_WATCHED_ACTIONS,
  VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  VIDEO_P100_WATCHED_ACTIONS,
  VIDEO_P25_WATCHED_ACTIONS,
  VIDEO_P50_WATCHED_ACTIONS,
  VIDEO_P75_WATCHED_ACTIONS,
  VIDEO_P95_WATCHED_ACTIONS,
  VIDEO_PLAY_ACTIONS,
  VIDEO_PLAY_CURVE_ACTIONS,
  VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  VIDEO_TIME_WATCHED_ACTIONS,
  WEBSITE_CTR,
  WEBSITE_PURCHASE_ROAS,
  CPM_METRICS,
  CPC_METRICS,
  FREQUENCY,
  REACH,
  BILLED_COST,
  GROSS_IMPRESSIONS,
  CONVERSION_RATE_TIKTOK,
  //RESULT_RATE_TIKTOK,
  VIDEO_VIEWS_P100_TIKTOK,
  AVERAGE_VIDEO_PLAY,
  ENGAGEMENT_RATE_TIKTOK,
  PROFILE_VISITS_TIKTOK,
  LIVE_VIEWS,
  APP_INSTALL_TIKTOK,
  //COST_PER_APP_INSTALL_TIKTOK,
  REGISTRATION,
  COST_PER_REGISTRATION,
  PURCHASE_TIKTOK,
  //COST_PER_PURCHASE_TIKTOK,
  PURCHASE_RATE,
  TOTAL_PURCHASE_VALUE,
  APP_EVENT_ADD_TO_CART_TIKTOK,
  //COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK,
  CHECKOUT_TIKTOK,
  //COST_PER_CHECKOUT_TIKTOK,
  VIEW_CONTENT_TIKTOK,
  //COST_PER_VIEW_CONTENT_TIKTOK,
  NEXT_DAY_OPEN,
  DAY7_RETENTION,
  CASH_SPEND,
  VOUCHER_SPEND,
  COST_PER_1000_REACHED,
  CONVERSION_RATE_V2,
  REAL_TIME_CONVERSION,
  REAL_TIME_COST_PER_CONVERSION,
  REAL_TIME_CONVERSION_RATE,
  REAL_TIME_CONVERSION_RATE_V2,
  REAL_TIME_RESULT,
  REAL_TIME_COST_PER_RESULT,
  REAL_TIME_RESULT_RATE,
  SECONDARY_GOAL_RESULT,
  COST_PER_SECONDARY_GOAL_RESULT,
  SECONDARY_GOAL_RESULT_RATE,
  //VIDEO_PLAY_ACTIONS_TIKTOK,
  VIDEO_WATCHED_2S,
  VIDEO_WATCHED_6S,
  VIDEO_VIEWS_P25,
  VIDEO_VIEWS_P50,
  VIDEO_VIEWS_P75,
  AVERAGE_VIDEO_PLAY_PER_USER,
  PAID_ENGAGED_VIEW,
  PAID_ENGAGEMENT_ENGAGED_VIEW,
  ENGAGED_VIEW_15S,
  PAID_ENGAGED_VIEW_15S,
  PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  CLICKS_ON_MUSIC_DISC,
  DUET_CLICKS,
  STITCH_CLICKS,
  SOUND_USAGE_CLICKS,
  ANCHOR_CLICKS,
  ANCHOR_CLICK_RATE,
  CLICKS_ON_HASHTAG_CHALLENGE,
  PROFILE_VISITS_RATE,
  TT_PLAYLIST_VISIT,
  TT_PLAYLIST_VISIT_RATE,
  LIVE_UNIQUE_VIEWS,
  LIVE_EFFECTIVE_VIEWS,
  LIVE_PRODUCT_CLICKS,
  INTERACTIVE_ADD_ON_IMPRESSIONS,
  INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  COUNTDOWN_STICKER_RECALL_CLICKS,
  IX_PAGE_DURATION_AVG,
  IX_PAGE_VIEWRATE_AVG,
  IX_VIDEO_VIEWS,
  IX_VIDEO_VIEWS_P25,
  IX_VIDEO_VIEWS_P50,
  IX_VIDEO_VIEWS_P75,
  IX_VIDEO_VIEWS_P100,
  IX_AVERAGE_VIDEO_PLAY,
  REAL_TIME_APP_INSTALL,
  REAL_TIME_APP_INSTALL_COST,
  REGISTRATION_RATE,
  TOTAL_REGISTRATION,
  COST_PER_TOTAL_REGISTRATION,
  TOTAL_PURCHASE,
  COST_PER_TOTAL_PURCHASE,
  VALUE_PER_TOTAL_PURCHASE,
  TOTAL_ACTIVE_PAY_ROAS,
  TOTAL_PURCHASE_ROAS_DAY0,
  TOTAL_PURCHASE_ROAS_DAY2,
  TOTAL_PURCHASE_ROAS_DAY6,
  TOTAL_PURCHASE_VALUE_DAY0,
  TOTAL_PURCHASE_VALUE_DAY2,
  TOTAL_PURCHASE_VALUE_DAY6,
  APP_EVENT_ADD_TO_CART_RATE,
  TOTAL_APP_EVENT_ADD_TO_CART,
  COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  CHECKOUT_RATE,
  TOTAL_CHECKOUT,
  COST_PER_TOTAL_CHECKOUT,
  VALUE_PER_CHECKOUT,
  TOTAL_CHECKOUT_VALUE,
  VIEW_CONTENT_RATE,
  TOTAL_VIEW_CONTENT,
  COST_PER_TOTAL_VIEW_CONTENT,
  VALUE_PER_TOTAL_VIEW_CONTENT,
  TOTAL_VIEW_CONTENT_VALUE,
  COST_PER_NEXT_DAY_OPEN,
  NEXT_DAY_OPEN_RATE,
  TOTAL_NEXT_DAY_OPEN,
  COST_PER_TOTAL_NEXT_DAY_OPEN,
  COST_PER_DAY7_RETENTION,
  DAY7_RETENTION_RATE,
  TOTAL_DAY7_RETENTION,
  COST_PER_TOTAL_DAY7_RETENTION,
  VALUE_PER_TOTAL_DAY7_RETENTION,
  TOTAL_DAY7_RETENTION_VALUE,
  ADD_PAYMENT_INFO,
  COST_PER_ADD_PAYMENT_INFO,
  ADD_PAYMENT_INFO_RATE,
  TOTAL_ADD_PAYMENT_INFO,
  COST_TOTAL_ADD_PAYMENT_INFO,
  ADD_TO_WISHLIST,
  COST_PER_ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_RATE,
  TOTAL_ADD_TO_WISHLIST,
  COST_PER_TOTAL_ADD_TO_WISHLIST,
  VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  TOTAL_ADD_TO_WISHLIST_VALUE,
  LAUNCH_APP,
  COST_PER_LAUNCH_APP,
  LAUNCH_APP_RATE,
  TOTAL_LAUNCH_APP,
  COST_PER_TOTAL_LAUNCH_APP,
  COMPLETE_TUTORIAL,
  COST_PER_COMPLETE_TUTORIAL,
  COMPLETE_TUTORIAL_RATE,
  TOTAL_COMPLETE_TUTORIAL,
  COST_PER_TOTAL_COMPLETE_TUTORIAL,
  VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  TOTAL_COMPLETE_TUTORIAL_VALUE,
  CREATE_GROUP,
  COST_PER_CREATE_GROUP,
  CREATE_GROUP_RATE,
  TOTAL_CREATE_GROUP,
  COST_PER_TOTAL_CREATE_GROUP,
  VALUE_PER_TOTAL_CREATE_GROUP,
  TOTAL_CREATE_GROUP_VALUE,
  JOIN_GROUP,
  COST_PER_JOIN_GROUP,
  JOIN_GROUP_RATE,
  TOTAL_JOIN_GROUP,
  COST_PER_TOTAL_JOIN_GROUP,
  VALUE_PER_TOTAL_JOIN_GROUP,
  TOTAL_JOIN_GROUP_VALUE,
  CREATE_GAMEROLE,
  COST_PER_CREATE_GAMEROLE,
  CREATE_GAMEROLE_RATE,
  TOTAL_CREATE_GAMEROLE,
  COST_PER_TOTAL_CREATE_GAMEROLE,
  VALUE_PER_TOTAL_CREATE_GAMEROLE,
  TOTAL_CREATE_GAMEROLE_VALUE,
  SPEND_CREDITS,
  COST_PER_SPEND_CREDITS,
  SPEND_CREDITS_RATE,
  TOTAL_SPEND_CREDITS,
  COST_PER_TOTAL_SPEND_CREDITS,
  VALUE_PER_TOTAL_SPEND_CREDITS,
  TOTAL_SPEND_CREDITS_VALUE,
  ACHIEVE_LEVEL,
  COST_PER_ACHIEVE_LEVEL,
  ACHIEVE_LEVEL_RATE,
  TOTAL_ACHIEVE_LEVEL,
  COST_PER_TOTAL_ACHIEVE_LEVEL,
  VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  TOTAL_ACHIEVE_LEVEL_VALUE,
  UNLOCK_ACHIEVEMENT,
  COST_PER_UNLOCK_ACHIEVEMENT,
  UNLOCK_ACHIEVEMENT_RATE,
  TOTAL_UNLOCK_ACHIEVEMENT,
  COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SALES_LEAD,
  COST_PER_SALES_LEAD,
  SALES_LEAD_RATE,
  TOTAL_SALES_LEAD,
  COST_PER_TOTAL_SALES_LEAD,
  VALUE_PER_TOTAL_SALES_LEAD,
  TOTAL_SALES_LEAD_VALUE,
  IN_APP_AD_CLICK,
  COST_PER_IN_APP_AD_CLICK,
  IN_APP_AD_CLICK_RATE,
  TOTAL_IN_APP_AD_CLICK,
  COST_PER_TOTAL_IN_APP_AD_CLICK,
  VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  TOTAL_IN_APP_AD_CLICK_VALUE,
  IN_APP_AD_IMPR,
  COST_PER_IN_APP_AD_IMPR,
  IN_APP_AD_IMPR_RATE,
  TOTAL_IN_APP_AD_IMPR,
  COST_PER_TOTAL_IN_APP_AD_IMPR,
  VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  TOTAL_IN_APP_AD_IMPR_VALUE,
  LOAN_APPLY,
  COST_PER_LOAN_APPLY,
  LOAN_APPLY_RATE,
  TOTAL_LOAN_APPLY,
  COST_PER_TOTAL_LOAN_APPLY,
  LOAN_CREDIT,
  COST_PER_LOAN_CREDIT,
  LOAN_CREDIT_RATE,
  TOTAL_LOAN_CREDIT,
  COST_PER_TOTAL_LOAN_CREDIT,
  LOAN_DISBURSEMENT,
  COST_PER_LOAN_DISBURSEMENT,
  LOAN_DISBURSEMENT_RATE,
  TOTAL_LOAN_DISBURSEMENT,
  COST_PER_TOTAL_LOAN_DISBURSEMENT,
  LOGIN,
  COST_PER_LOGIN,
  LOGIN_RATE,
  TOTAL_LOGIN,
  COST_PER_TOTAL_LOGIN,
  RATINGS,
  COST_PER_RATINGS,
  RATINGS_RATE,
  TOTAL_RATINGS,
  COST_PER_TOTAL_RATINGS,
  VALUE_PER_TOTAL_RATINGS,
  TOTAL_RATINGS_VALUE,
  SEARCH_TIKTOK,
  COST_PER_SEARCH,
  SEARCH_RATE,
  TOTAL_SEARCH,
  COST_PER_TOTAL_SEARCH,
  START_TRIAL,
  COST_PER_START_TRIAL,
  START_TRIAL_RATE,
  TOTAL_START_TRIAL,
  COST_PER_TOTAL_START_TRIAL,
  SUBSCRIBE,
  COST_PER_SUBSCRIBE,
  SUBSCRIBE_RATE,
  TOTAL_SUBSCRIBE,
  COST_PER_TOTAL_SUBSCRIBE,
  VALUE_PER_TOTAL_SUBSCRIBE,
  TOTAL_SUBSCRIBE_VALUE,
  UNIQUE_CUSTOM_APP_EVENTS,
  COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENT_RATE,
  CUSTOM_APP_EVENTS,
  COST_PER_CUSTOM_APP_EVENT,
  VALUE_PER_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENTS_VALUE,
  UNIQUE_AD_IMPRESSION_EVENTS,
  COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  ADS_IMPRESSION_EVENTS,
  COST_PRE_AD_IMPRESSION_EVENT,
  VALUE_PER_AD_IMPRESSION_EVENT,
  TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  TOTAL_AD_IMPRESSION_ROAS,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  AD_IMPRESSION_AD_REVENUE_DAY0,
  AD_IMPRESSION_AD_REVENUE_DAY2,
  AD_IMPRESSION_AD_REVENUE_DAY6,
  COMPLETE_PAYMENT_ROAS,
  COMPLETE_PAYMENT,
  COST_PER_COMPLETE_PAYMENT,
  COMPLETE_PAYMENT_RATE,
  VALUE_PER_COMPLETE_PAYMENT,
  TOTAL_COMPLETE_PAYMENT_RATE,
  TOTAL_LANDING_PAGE_VIEW,
  COST_PER_LANDING_PAGE_VIEW,
  LANDING_PAGE_VIEW_RATE,
  TOTAL_PAGEVIEW,
  COST_PER_PAGEVIEW,
  PAGEVIEW_RATE,
  AVG_VALUE_PER_PAGEVIEW,
  TOTAL_VALUE_PER_PAGEVIEW,
  PAGE_BROWSE_VIEW,
  COST_PER_PAGE_BROWSE_VIEW,
  PAGE_BROWSE_VIEW_RATE,
  TOTAL_PAGE_BROWSE_VIEW_VALUE,
  VALUE_PER_PAGE_BROWSE_VIEW,
  BUTTON_CLICK,
  COST_PER_BUTTON_CLICK,
  BUTTON_CLICK_RATE,
  VALUE_PER_BUTTON_CLICK,
  TOTAL_BUTTON_CLICK_VALUE,
  ONLINE_CONSULT,
  COST_PER_ONLINE_CONSULT,
  ONLINE_CONSULT_RATE,
  VALUE_PER_ONLINE_CONSULT,
  TOTAL_ONLINE_CONSULT_VALUE,
  USER_REGISTRATION,
  COST_PER_USER_REGISTRATION,
  USER_REGISTRATION_RATE,
  VALUE_PER_USER_REGISTRATION,
  TOTAL_USER_REGISTRATION_VALUE,
  PAGE_CONTENT_VIEW_EVENTS,
  COST_PER_PAGE_CONTENT_VIEW_EVENT,
  PAGE_CONTENT_VIEW_EVENT_RATE,
  VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  PRODUCT_DETAILS_PAGE_BROWSE,
  COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  WEB_EVENT_ADD_TO_CART,
  COST_PER_WEB_EVENT_ADD_TO_CART,
  WEB_EVENT_ADD_TO_CART_RATE,
  VALUE_PER_WEB_EVENT_ADD_TO_CART,
  TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  ON_WEB_ORDER,
  COST_PER_ON_WEB_ORDER,
  ON_WEB_ORDER_RATE,
  VALUE_PER_ON_WEB_ORDER,
  TOTAL_ON_WEB_ORDER_VALUE,
  INITIATE_CHECKOUT,
  COST_PER_INITIATE_CHECKOUT,
  INITIATE_CHECKOUT_RATE,
  VALUE_PER_INITIATE_CHECKOUT,
  TOTAL_INITIATE_CHECKOUT_VALUE,
  ADD_BILLING,
  COST_PER_ADD_BILLING,
  ADD_BILLING_RATE,
  VALUE_PER_ADD_BILLING,
  TOTAL_ADD_BILLING_VALUE,
  PAGE_EVENT_SEARCH,
  COST_PER_PAGE_EVENT_SEARCH,
  PAGE_EVENT_SEARCH_RATE,
  VALUE_PER_PAGE_EVENT_SEARCH,
  TOTAL_PAGE_EVENT_SEARCH_VALUE,
  FORM_TIKTOK,
  COST_PER_FORM,
  FORM_RATE,
  VALUE_PER_FORM,
  TOTAL_FORM_VALUE,
  DOWNLOAD_START,
  COST_PER_DOWNLOAD_START,
  DOWNLOAD_START_RATE,
  VALUE_PER_DOWNLOAD_START,
  TOTAL_DOWNLOAD_START_VALUE,
  ON_WEB_ADD_TO_WISHLIST,
  COST_PER_ON_WEB_ADD_TO_WISHLIST,
  ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  ON_WEB_SUBSCRIBE,
  COST_PER_ON_WEB_SUBSCRIBE,
  ON_WEB_SUBSCRIBE_PER_CLICK,
  VALUE_PER_ON_WEB_SUBSCRIBE,
  TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  WEBSITE_TOTAL_FIND_LOCATION,
  WEBSITE_COST_PER_FIND_LOCATION,
  WEBSITE_FIND_LOCATION_RATE,
  WEBSITE_VALUE_PER_FIND_LOCATION,
  WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  WEBSITE_TOTAL_SCHEDULE,
  WEBSITE_COST_PER_SCHEDULE,
  WEBSITE_SCHEDULE_RATE,
  WEBSITE_VALUE_PER_SCHEDULE,
  WEBSITE_TOTAL_SCHEDULE_VALUE,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  CUSTOM_PAGE_EVENTS,
  COST_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENT_RATE,
  VALUE_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENTS_VALUE,
  ONSITE_PURCHASES_ROAS,
  ONSITE_TOTAL_PURCHASE,
  ONSITE_COST_PER_PURCHASE,
  ONSITE_PURCHASE_RATE,
  ONSITE_VALUE_PER_PURCHASE,
  ONSITE_TOTAL_PURCHASE_VALUE,
  ONSITE_TOTAL_CHECKOUT_INITIATION,
  ONSITE_COST_PER_CHECKOUT_INITIATION,
  ONSITE_CHECKOUT_INITIATION_RATE,
  ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  ONSITE_TOTAL_ADD_TO_CART,
  ONSITE_COST_PER_ADD_TO_CART,
  ONSITE_ADD_TO_CART_RATE,
  ONSITE_VALUE_PER_ADD_TO_CART,
  ONSITE_TOTAL_ADD_TO_CART_VALUE,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  ONSITE_ADD_TO_WISHLIST,
  COST_PER_ONSITE_ADD_TO_WISHLIST,
  ONSITE_ADD_TO_WISHLIST_RATE,
  VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  ONSITE_ADD_BILLING,
  COST_PER_ONSITE_ADD_BILLING,
  ONSITE_ADD_BILLING_RATE,
  VALUE_PER_ONSITE_ADD_BILLING,
  TOTAL_ONSITE_ADD_BILLING_VALUE,
  ONSITE_FORM,
  COST_PER_ONSITE_FORM,
  ONSITE_FORM_RATE,
  VALUE_PER_ONSITE_FORM,
  TOTAL_ONSITE_FORM_VALUE,
  ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  ONSITE_DOWNLOAD_START,
  COST_PER_ONSITE_DOWNLOAD_START,
  ONSITE_DOWNLOAD_START_RATE,
  ONSITE_DESTINATION_VISITS,
  COST_PER_ONSITE_DESTINATION_VISIT,
  ONSITE_DESTINATION_VISIT_RATE,
  IX_PAGE_VIEW_COUNT,
  COST_PER_IX_PAGE_VIEW_COUNT,
  IX_PAGE_VIEW_COUNT_RATE,
  IX_BUTTON_CLICK_COUNT,
  COST_PER_IX_BUTTON_CLICK_COUNT,
  IX_BUTTON_CLICK_COUNT_RATE,
  IX_PRODUCT_CLICK_COUNT,
  COST_PER_IX_PRODUCT_CLICK_COUNT,
  IX_PRODUCT_CLICK_COUNT_RATE,
  OFFLINE_TOTAL_CRM_EVENTS,
  OFFLINE_COST_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_RATE,
  OFFLINE_VALUE_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_VALUE,
  OFFLINE_SHOPPING_EVENTS,
  COST_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENT_RATE,
  VALUE_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENTS_VALUE,
  OFFLINE_SHOPPING_EVENTS_ROAS,
  OFFLINE_CONTACT_EVENTS,
  COST_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENT_RATE,
  VALUE_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENTS_VALUE,
  OFFLINE_SUBSCRIBE_EVENTS,
  COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENT_RATE,
  VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  OFFLINE_FORM_EVENTS,
  COST_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENT_RATE,
  VALUE_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENTS_VALUE,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  OFFLINE_ADD_TO_CART_EVENTS,
  COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  OFFLINE_ADD_TO_WISHLIST_EVENTS,
  COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  OFFLINE_CLICK_BUTTON_EVENTS,
  COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENT_RATE,
  VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  OFFLINE_DOWNLOAD_EVENTS,
  COST_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENT_RATE,
  VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENTS_VALUE,
  OFFLINE_INITIATE_CHECKOUT_EVENTS,
  COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  OFFLINE_PLACE_ORDER_EVENTS,
  COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENT_RATE,
  VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  OFFLINE_SEARCH_EVENTS,
  COST_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENT_RATE,
  VALUE_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENTS_VALUE,
  OFFLINE_VIEW_CONTENT_EVENTS,
  COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENT_RATE,
  VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  OFFLINE_PREFERRED_LEADS,
  OFFLINE_COST_PER_PREFERRED_LEAD,
  OFFLINE_PREFERRED_LEAD_RATE,
  OFFLINE_TOTAL_FIND_LOCATION,
  OFFLINE_COST_PER_FIND_LOCATION,
  OFFLINE_FIND_LOCATION_RATE,
  OFFLINE_VALUE_PER_FIND_LOCATION,
  OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  OFFLINE_TOTAL_SCHEDULE,
  OFFLINE_COST_PER_SCHEDULE,
  OFFLINE_SCHEDULE_RATE,
  OFFLINE_VALUE_PER_SCHEDULE,
  OFFLINE_TOTAL_SCHEDULE_VALUE,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  OFFLINE_TOTAL_CUSTOM_EVENTS,
  OFFLINE_COST_PER_CUSTOM_EVENT,
  OFFLINE_CUSTOM_EVENT_RATE,
  OFFLINE_VALUE_PER_CUSTOM_EVENT,
  OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  ONSITE_SHOPPING_ROAS,
  ONSITE_SHOPPING,
  COST_PER_ONSITE_SHOPPING,
  ONSITE_SHOPPING_RATE,
  VALUE_PER_ONSITE_SHOPPING,
  TOTAL_ONSITE_SHOPPING_VALUE,
  SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  SHOP_TOTAL_ITEMS_PURCHASED,
  ONSITE_INITIATE_CHECKOUT_COUNT,
  COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  ONSITE_ON_WEB_DETAIL,
  COST_PER_ONSITE_ON_WEB_DETAIL,
  ONSITE_ON_WEB_DETAIL_RATE,
  VALUE_PER_ONSITE_ON_WEB_DETAIL,
  TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  ONSITE_ON_WEB_CART,
  COST_PER_ONSITE_ON_WEB_CART,
  ONSITE_ON_WEB_CART_RATE,
  VALUE_PER_ONSITE_ON_WEB_CART,
  TOTAL_ONSITE_ON_WEB_CART_VALUE,
  VTA_CONVERSION,
  COST_PER_VTA_CONVERSION,
  CTA_CONVERSION,
  COST_PER_CTA_CONVERSION,
  ENGAGED_VIEW_THROUGH_CONVERSIONS,
  COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  VTA_APP_INSTALL,
  COST_PER_VTA_APP_INSTALL,
  CTA_APP_INSTALL,
  COST_PER_CTA_APP_INSTALL,
  EVTA_APP_INSTALL,
  COST_PER_EVTA_APP_INSTALL,
  VTA_REGISTRATION,
  COST_PER_VTA_REGISTRATION,
  CTA_REGISTRATION,
  COST_PER_CTA_REGISTRATION,
  EVTA_REGISTRATION,
  COST_PER_EVTA_REGISTRATION,
  VTA_PURCHASE,
  COST_PER_VTA_PURCHASE,
  CTA_PURCHASE,
  COST_PER_CTA_PURCHASE,
  EVTA_PURCHASE,
  COST_PER_EVTA_PURCHASE,
  VTA_COMPLETE_PAYMENT,
  COST_PER_VTA_PAYMENTS_COMPLETED,
  EVTA_PAYMENTS_COMPLETED,
  COST_PER_EVTA_PAYMENTS_COMPLETED,
  VTA_COMPLETE_PAYMENT_VALUE,
  VTA_COMPLETE_PAYMENT_ROAS,
  SKAN_RESULT,
  SKAN_COST_PER_RESULT,
  SKAN_RESULT_RATE,
  SKAN_CONVERSION,
  SKAN_COST_PER_CONVERSION,
  SKAN_CONVERSION_RATE,
  SKAN_CONVERSION_RATE_V2,
  SKAN_CLICK_TIME_CONVERSION,
  SKAN_CLICK_TIME_COST_PER_CONVERSION,
  SKAN_CLICK_TIME_CONVERSION_RATE,
  SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  SKAN_APP_INSTALL,
  SKAN_COST_PER_APP_INSTALL,
  SKAN_APP_INSTALL_WITHHELD,
  SKAN_REGISTRATION,
  SKAN_COST_PER_REGISTRATION,
  SKAN_REGISTRATION_RATE,
  SKAN_TOTAL_REGISTRATION,
  SKAN_COST_PER_TOTAL_REGISTRATION,
  SKAN_PURCHASE,
  SKAN_COST_PER_PURCHASE,
  SKAN_PURCHASE_RATE,
  SKAN_TOTAL_PURCHASE,
  SKAN_COST_PER_TOTAL_PURCHASE,
  SKAN_TOTAL_PURCHASE_VALUE,
  SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  SKAN_ADD_TO_CART,
  SKAN_COST_PER_ADD_TO_CART,
  SKAN_ADD_TO_CART_RATE,
  SKAN_TOTAL_ADD_TO_CART,
  SKAN_COST_PER_TOTAL_ADD_TO_CART,
  SKAN_TOTAL_ADD_TO_CART_VALUE,
  SKAN_CHECKOUT,
  SKAN_COST_PER_CHECKOUT,
  SKAN_CHECKOUT_RATE,
  SKAN_TOTAL_CHECKOUT,
  SKAN_COST_PER_TOTAL_CHECKOUT,
  SKAN_TOTAL_CHECKOUT_VALUE,
  SKAN_VIEW_CONTENT,
  SKAN_COST_PER_VIEW_CONTENT,
  SKAN_VIEW_CONTENT_RATE,
  SKAN_TOTAL_VIEW_CONTENT,
  SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  SKAN_TOTAL_VIEW_CONTENT_VALUE,
  SKAN_ADD_PAYMENT_INFO,
  SKAN_COST_PER_ADD_PAYMENT_INFO,
  SKAN_ADD_PAYMENT_INFO_RATE,
  SKAN_TOTAL_ADD_PAYMENT_INFO,
  SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  SKAN_ADD_TO_WISHLIST,
  SKAN_COST_PER_ADD_TO_WISHLIST,
  SKAN_ADD_TO_WISHLIST_RATE,
  SKAN_TOTAL_ADD_TO_WISHLIST,
  SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  SKAN_LAUNCH_APP,
  SKAN_COST_PER_LAUNCH_APP,
  SKAN_LAUNCH_APP_RATE,
  SKAN_TOTAL_LAUNCH_APP,
  SKAN_COST_PER_TOTAL_LAUNCH_APP,
  SKAN_COMPLETE_TUTORIAL,
  SKAN_COST_PER_COMPLETE_TUTORIAL,
  SKAN_COMPLETE_TUTORIAL_RATE,
  SKAN_TOTAL_COMPLETE_TUTORIAL,
  SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  SKAN_CREATE_GROUP,
  SKAN_COST_PER_CREATE_GROUP,
  SKAN_CREATE_GROUP_RATE,
  SKAN_TOTAL_CREATE_GROUP,
  SKAN_COST_PER_TOTAL_CREATE_GROUP,
  SKAN_TOTAL_CREATE_GROUP_VALUE,
  SKAN_JOIN_GROUP,
  SKAN_COST_PER_JOIN_GROUP,
  SKAN_JOIN_GROUP_RATE,
  SKAN_TOTAL_JOIN_GROUP,
  SKAN_COST_PER_TOTAL_JOIN_GROUP,
  SKAN_TOTAL_JOIN_GROUP_VALUE,
  SKAN_CREATE_GAMEROLE,
  SKAN_COST_PER_CREATE_GAMEROLE,
  SKAN_CREATE_GAMEROLE_RATE,
  SKAN_TOTAL_CREATE_GAMEROLE,
  SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  SKAN_SPEND_CREDITS,
  SKAN_COST_PER_SPEND_CREDITS,
  SKAN_SPEND_CREDITS_RATE,
  SKAN_TOTAL_SPEND_CREDITS,
  SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  SKAN_TOTAL_SPEND_CREDITS_VALUE,
  SKAN_ACHIEVE_LEVEL,
  SKAN_COST_PER_ACHIEVE_LEVEL,
  SKAN_ACHIEVE_LEVEL_RATE,
  SKAN_TOTAL_ACHIEVE_LEVEL,
  SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  SKAN_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  SKAN_UNLOCK_ACHIEVEMENT_RATE,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SKAN_SALES_LEAD,
  SKAN_COST_PER_SALES_LEAD,
  SKAN_SALES_LEAD_RATE,
  SKAN_TOTAL_SALES_LEAD,
  SKAN_COST_PER_TOTAL_SALES_LEAD,
  SKAN_TOTAL_SALES_LEAD_VALUE,
  SKAN_IN_APP_AD_CLICK,
  SKAN_COST_PER_IN_APP_AD_CLICK,
  SKAN_IN_APP_AD_CLICK_RATE,
  SKAN_TOTAL_IN_APP_AD_CLICK,
  SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  SKAN_IN_APP_AD_IMPR,
  SKAN_COST_PER_IN_APP_AD_IMPR,
  SKAN_IN_APP_AD_IMPR_RATE,
  SKAN_TOTAL_IN_APP_AD_IMPR,
  SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  SKAN_LOAN_APPLY,
  SKAN_COST_PER_LOAN_APPLY,
  SKAN_LOAN_APPLY_RATE,
  SKAN_TOTAL_LOAN_APPLY,
  SKAN_COST_PER_TOTAL_LOAN_APPLY,
  SKAN_LOAN_CREDIT,
  SKAN_COST_PER_LOAN_CREDIT,
  SKAN_LOAN_CREDIT_RATE,
  SKAN_TOTAL_LOAN_CREDIT,
  SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  SKAN_LOAN_DISBURSEMENT,
  SKAN_COST_PER_LOAN_DISBURSEMENT,
  SKAN_LOAN_DISBURSEMENT_RATE,
  SKAN_TOTAL_LOAN_DISBURSEMENT,
  SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  SKAN_LOGIN,
  SKAN_COST_PER_LOGIN,
  SKAN_LOGIN_RATE,
  SKAN_TOTAL_LOGIN,
  SKAN_COST_PER_TOTAL_LOGIN,
  SKAN_RATINGS,
  SKAN_COST_PER_RATINGS,
  SKAN_RATINGS_RATE,
  SKAN_TOTAL_RATINGS,
  SKAN_COST_PER_TOTAL_RATINGS,
  SKAN_TOTAL_RATINGS_VALUE,
  SKAN_SEARCH,
  SKAN_COST_PER_SEARCH,
  SKAN_SEARCH_RATE,
  SKAN_TOTAL_SEARCH,
  SKAN_COST_PER_TOTAL_SEARCH,
  SKAN_START_TRIAL,
  SKAN_COST_PER_START_TRIAL,
  SKAN_START_TRIAL_RATE,
  SKAN_TOTAL_START_TRIAL,
  SKAN_COST_PER_TOTAL_START_TRIAL,
  SKAN_SUBSCRIBE,
  SKAN_COST_PER_SUBSCRIBE,
  SKAN_SUBSCRIBE_RATE,
  SKAN_TOTAL_SUBSCRIBE,
  SKAN_COST_PER_TOTAL_SUBSCRIBE,
  SKAN_TOTAL_SUBSCRIBE_VALUE,
  SKAN_VTA_CONVERSION,
  SKAN_COST_PER_VTA_CONVERSION,
  SKAN_VTA_APP_INSTALL,
  SKAN_COST_PER_VTA_APP_INSTALL,
  SKAN_VTA_REGISTRATION,
  SKAN_COST_PER_VTA_REGISTRATION,
  SKAN_VTA_PURCHASE,
  SKAN_COST_PER_VTA_PURCHASE,
  SKAN_CTA_CONVERSION,
  SKAN_COST_PER_CTA_CONVERSION,
  SKAN_CTA_APP_INSTALL,
  SKAN_COST_PER_CTA_APP_INSTALL,
  SKAN_CTA_REGISTRATION,
  SKAN_COST_PER_CTA_REGISTRATION,
  SKAN_CTA_PURCHASE,
  SKAN_COST_PER_CTA_PURCHASE,
  COMMENTS_LINKEDIN,
  COMPANY_PAGE_CLICKS_LINKEDIN,
  EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  FOLLOWS_LINKEDIN,
  FULL_SCREEN_PLAYS_LINKEDIN,
  LANDING_PAGE_CLICKS_LINKEDIN,
  LIKES_LINKEDIN,
  REACTIONS_LINKEDIN,
  SHARES_LINKEDIN,
  TOTAL_ENGAGEMENTS_LINKEDIN,
  VIDEO_COMPLETIONS_LINKEDIN,
  VIDEO_STARTS_LINKEDIN,
  VIDEO_VIEWS_LINKEDIN,
  ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN,
  LEAD_FORM_COMPLETION_RATE_LINKEDIN,
  VALID_WORK_EMAIL_LEADS_LINKEDIN,
  DOWNLOAD_CLICKS_LINKEDIN,
  DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN,
  DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN,
  DOCUMENT_COMPLETIONS_LINKEDIN,
  VIDEO_HOOK_RATE,
  VIDEO_RETENTION_RATE,
} from "../../../../i18n/keysTranslations";

// Metrics configuration by platform (excluding general metrics to avoid duplicates)
export const PLATFORM_METRICS = {
  google: [
    "allConversions",
    "allConversionsFromInteractionsRate",
    "allConversionsValue",
    "averageCartSize",
    "averageCost",
    "averageCpc",
    "averageOrderValueMicros",
    "conversionsFromInteractionsRate",
    "conversionsValue",
    "costOfGoodsSoldMicros",
    "costPerAllConversions",
    "costPerConversion",
    "crossDeviceConversions",
    "crossDeviceConversionsValueMicros",
    "crossSellCostOfGoodsSoldMicros",
    "crossSellGrossProfitMicros",
    "crossSellRevenueMicros",
    "crossSellUnitsSold",
    "grossProfitMargin",
    "grossProfitMicros",
    "interactionRate",
    "interactions",
    "leadCostOfGoodsSoldMicros",
    "leadGrossProfitMicros",
    "leadRevenueMicros",
    "leadUnitsSold",
    "orders",
    "revenueMicros",
    "roas",
    "valuePerAllConversions",
    "valuePerConversion",
    "viewThroughConversions",
  ],
  meta: [
    "frequency",
    "cpp",
    "estimatedAdRecallers",
    "instagramProfileFollow",
    "costPerEstimatedAdRecallers",
    "costPerInlineLinkClick",
    "costPerInlinePostEngagement",
    "costPerUniqueClick",
    "costPerUniqueInlineLinkClick",
    "costPerUniqueOutboundClick",
    "costPerThruplay",
    "costPer_15SecVideoView",
    "costPerResult",
    "costPerUniqueActionType",
    "costPerOutboundClick",
    "costPerActionType",
    "actions",
    "outboundClicks",
    "outboundClicksCtr",
    "inlineLinkClicks",
    "inlineLinkClickCtr",
    "inlinePostEngagement",
    "resultRate",
    "results",
    "roas",
    "socialSpend",
    "shopsAssistedPurchases",
    "marketingMessagesDeliveryRate",
    "fullViewImpressions",
    "fullViewReach",
    "videoPlayActions",
    "videoAvgTimeWatchedActions",
    "videoP25WatchedActions",
    "videoP50WatchedActions",
    "videoP75WatchedActions",
    "videoP95WatchedActions",
    "videoP100WatchedActions",
    "video_30SecWatchedActions",
    "websiteCtr",
    "actionValues",
    "adClickActions",
    "adImpressionActions",
    "auctionBid",
    "auctionCompetitiveness",
    "auctionMaxCompetitorBid",
    "canvasAvgViewPercent",
    "canvasAvgViewTime",
    "catalogSegmentActions",
    "catalogSegmentValue",
    "catalogSegmentValueMobilePurchaseRoas",
    "catalogSegmentValueOmniPurchaseRoas",
    "catalogSegmentValueWebsitePurchaseRoas",
    "conversionValues",
    "convertedProductAppCustomEventFbMobilePurchase",
    "convertedProductAppCustomEventFbMobilePurchaseValue",
    "convertedProductOfflinePurchase",
    "convertedProductOfflinePurchaseValue",
    "convertedProductOmniPurchase",
    "convertedProductOmniPurchaseValues",
    "convertedProductQuantity",
    "convertedProductValue",
    "convertedProductWebsitePixelPurchase",
    "convertedProductWebsitePixelPurchaseValue",
    "convertedPromotedProductAppCustomEventFbMobilePurchase",
    "convertedPromotedProductAppCustomEventFbMobilePurchaseValue",
    "convertedPromotedProductOfflinePurchase",
    "convertedPromotedProductOfflinePurchaseValue",
    "convertedPromotedProductOmniPurchase",
    "convertedPromotedProductOmniPurchaseValues",
    "convertedPromotedProductQuantity",
    "convertedPromotedProductValue",
    "convertedPromotedProductWebsitePixelPurchase",
    "convertedPromotedProductWebsitePixelPurchaseValue",
    "costPer15SecVideoView",
    "costPer2SecContinuousVideoView",
    "costPerAdClick",
    "costPerDdaCountbyConvs",
    "costPerOneThousandAdImpression",
    "costPerObjectiveResult",
    "costPerUniqueConversion",
    "ddaCountbyConvs",
    "ddaResults",
    "instantExperienceClicksToOpen",
    "instantExperienceClicksToStart",
    "instantExperienceOutboundClicks",
    "interactiveComponentTap",
    "landingPageViewPerLinkClick",
    "objectiveResultRate",
    "objectiveResults",
    "purchasePerLandingPageView",
    "qualifyingQuestionQualifyAnswerRate",
    "totalCardView",
    "video30SecWatchedActions",
    "videoContinuous2SecWatchedActions",
    "videoPlayCurveActions",
    "videoPlayRetention0To15sActions",
    "videoPlayRetention20To60sActions",
    "videoPlayRetentionGraphActions",
    "videoTimeWatchedActions",
    "websitePurchaseRoas",
    "videoHookRate",
    "videoRetentionRate",
  ],
  tiktok: [
    "billedCost",
    "grossImpressions",
    "conversionRate",
    "conversionRateV2",
    "resultRate",
    "videoViewsP100",
    "videoViewsP25",
    "videoViewsP50",
    "videoViewsP75",
    "averageVideoPlay",
    "averageVideoPlayPerUser",
    "engagementRate",
    "follows",
    "likes",
    "comments",
    "shares",
    "engagements",
    "videoPlayActions",
    "profileVisits",
    "profileVisitsRate",
    "liveViews",
    "appInstall",
    "costPerAppInstall",
    "registration",
    "costPerRegistration",
    "purchase",
    "costPerPurchase",
    "purchaseRate",
    "totalPurchaseValue",
    "appEventAddToCart",
    "costPerAppEventAddToCart",
    "checkout",
    "costPerCheckout",
    "viewContent",
    "costPerViewContent",
    "nextDayOpen",
    "day7Retention",
    "roas",
    "costPer1000Reached",
    "videoWatched2s",
    "videoWatched6s",
    "engagedView15s",
    "engagedView",
    "paidEngagedView",
    "paidEngagedView15s",
    "completePaymentRoas",
    "completePayment",
    "costPerCompletePayment",
    "completePaymentRate",
    "valuePerCompletePayment",
    "totalCompletePaymentRate",
    "conversion",
    "costPerConversion",
    "realTimeConversion",
    "realTimeCostPerConversion",
    "realTimeConversionRate",
    "realTimeConversionRateV2",
    "initiateCheckout",
    "costPerInitiateCheckout",
    "initiateCheckoutRate",
    "totalInitiateCheckoutValue",
    "onWebOrder",
    "costPerOnWebOrder",
    "onWebOrderRate",
    "totalOnWebOrderValue",
    "webEventAddToCart",
    "costPerWebEventAddToCart",
    "webEventAddToCartRate",
    "totalWebEventAddToCartValue",
    "productDetailsPageBrowse",
    "costPerProductDetailsPageBrowse",
    "productDetailsPageBrowseRate",
    "valuePerProductDetailsPageBrowse",
    "totalProductDetailsPageBrowseValue",
    "totalLandingPageView",
    "costPerLandingPageView",
    "landingPageViewRate",
    "totalPageview",
    "costPerPageview",
    "pageviewRate",
    "pageContentViewEvents",
    "costPerPageContentViewEvent",
    "pageContentViewEventRate",
    "totalPageViewContentEventsValue",
    "addBilling",
    "costPerAddBilling",
    "addBillingRate",
    "totalAddBillingValue",
    "pageEventSearch",
    "costPerPageEventSearch",
    "pageEventSearchRate",
    "vtaCompletePayment",
    "vtaCompletePaymentRoas",
    "vtaCompletePaymentValue",
    "costPerVtaPaymentsCompleted",
    "ctaConversion",
    "costPerCtaConversion",
    "engagedViewThroughConversions",
    "costPerEngagedViewThroughConversion",
  ],
  linkedIn: [
    "comments",
    "companyPageClicks",
    "externalWebsiteConversions",
    "follows",
    "fullScreenPlays",
    "landingPageClicks",
    "likes",
    "reactions",
    "returnOnAdSpend",
    "shares",
    "totalEngagements",
    "videoCompletions",
    "videoStarts",
    "videoViews",
    "oneClickLeadFormOpens",
    "leadFormCompletionRate",
    "validWorkEmailLeads",
    "downloadClicks",
    "documentFirstQuartileCompletions",
    "documentMidpointCompletions",
    "documentThirdQuartileCompletions",
    "documentCompletions",
  ],
};

// Specific order: 1.Impressions, 2.Clicks, 3.CTR, 4.Results, 5.CPA, 6.Spend
export const GENERAL_METRICS_ORDERED = [
  "impressions", // 1. Impressions
  "click", // 2. Clicks
  "ctr", // 3. CTR
  "mainAction", // 4. Results
  "costPerMainAction", // 5. CPA
  "spend", // 6. Spend
];

// Additional general metrics (shown after main order)
export const GENERAL_METRICS_ADDITIONAL = ["cpc", "cpm", "reach"];

// Extended translations mapping
export const MAP_TRANSLATIONS = {
  // General metrics
  spend: SPEND,
  impressions: IMPRESSIONS,
  click: CLICKS,
  ctr: CTR,
  mainAction: RESULTS,
  costPerMainAction: CPA,
  reach: REACH,
  frequency: FREQUENCY,
  cpm: CPM_METRICS,
  cpc: CPC_METRICS,

  // Google specific metrics
  allConversions: ALL_CONVERSIONS,
  allConversionsFromInteractionsRate: ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  allConversionsValue: ALL_CONVERSIONS_VALUE,
  averageCartSize: AVERAGE_CART_SIZE,
  averageCost: AVERAGE_COST,
  averageCpc: AVERAGE_CPC,
  averageOrderValueMicros: AVERAGE_ORDER_VALUE_MICROS,
  conversionsFromInteractionsRate: CONVERSIONS_FROM_INTERACTIONS_RATE,
  conversionsValue: CONVERSIONS_VALUE,
  costOfGoodsSoldMicros: COST_OF_GOODS_SOLD_MICROS,
  costPerAllConversions: COST_PER_ALL_CONVERSIONS,
  costPerAppEventAddToCart: COST_PER_APP_EVENT_ADD_TO_CART,
  costPerAppInstall: COST_PER_APP_INSTALL,
  costPerCheckout: COST_PER_CHECKOUT,
  costPerConversion: COST_PER_CONVERSION,
  costPerPurchase: COST_PER_PURCHASE,
  costPerViewContent: COST_PER_VIEW_CONTENT,
  crossDeviceConversions: CROSS_DEVICE_CONVERSIONS,
  crossDeviceConversionsValueMicros: CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  crossSellCostOfGoodsSoldMicros: CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  crossSellGrossProfitMicros: CROSS_SELL_GROSS_PROFIT_MICROS,
  crossSellRevenueMicros: CROSS_SELL_REVENUE_MICROS,
  crossSellUnitsSold: CROSS_SELL_UNITS_SOLD,
  grossProfitMargin: GROSS_PROFIT_MARGIN,
  grossProfitMicros: GROSS_PROFIT_MICROS,
  interactionRate: INTERACTION_RATE,
  interactions: INTERACTIONS_METRICS,
  leadCostOfGoodsSoldMicros: LEAD_COST_OF_GOODS_SOLD_MICROS,
  leadGrossProfitMicros: LEAD_GROSS_PROFIT_MICROS,
  leadRevenueMicros: LEAD_REVENUE_MICROS,
  leadUnitsSold: LEAD_UNITS_SOLD,
  orders: ORDERS_METRICS,
  revenueMicros: REVENUE_MICROS,
  valuePerAllConversions: VALUE_PER_ALL_CONVERSIONS,
  valuePerConversion: VALUE_PER_CONVERSION,
  viewThroughConversions: VIEW_THROUGH_CONVERSIONS,

  // Meta specific metrics
  actionValues: ACTION_VALUES,
  actions: ACTIONS_METRICS,
  adClickActions: AD_CLICK_ACTIONS,
  adImpressionActions: AD_IMPRESSION_ACTIONS,
  auctionBid: AUCTION_BID,
  auctionCompetitiveness: AUCTION_COMPETITIVENESS,
  auctionMaxCompetitorBid: AUCTION_MAX_COMPETITOR_BID,
  canvasAvgViewPercent: CANVAS_AVG_VIEW_PERCENT,
  canvasAvgViewTime: CANVAS_AVG_VIEW_TIME,
  catalogSegmentActions: CATALOG_SEGMENT_ACTIONS,
  catalogSegmentValue: CATALOG_SEGMENT_VALUE,
  catalogSegmentValueMobilePurchaseRoas:
    CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  catalogSegmentValueOmniPurchaseRoas: CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  catalogSegmentValueWebsitePurchaseRoas:
    CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  conversionValues: CONVERSION_VALUES,
  convertedProductAppCustomEventFbMobilePurchase:
    CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  convertedProductAppCustomEventFbMobilePurchaseValue:
    CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  convertedProductOfflinePurchase: CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  convertedProductOfflinePurchaseValue:
    CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  convertedProductOmniPurchase: CONVERTED_PRODUCT_OMNI_PURCHASE,
  convertedProductOmniPurchaseValues: CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  convertedProductQuantity: CONVERTED_PRODUCT_QUANTITY,
  convertedProductValue: CONVERTED_PRODUCT_VALUE,
  convertedProductWebsitePixelPurchase:
    CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  convertedProductWebsitePixelPurchaseValue:
    CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  convertedPromotedProductAppCustomEventFbMobilePurchase:
    CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  convertedPromotedProductAppCustomEventFbMobilePurchaseValue:
    CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  convertedPromotedProductOfflinePurchase:
    CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  convertedPromotedProductOfflinePurchaseValue:
    CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  convertedPromotedProductOmniPurchase:
    CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  convertedPromotedProductOmniPurchaseValues:
    CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  convertedPromotedProductQuantity: CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  convertedPromotedProductValue: CONVERTED_PROMOTED_PRODUCT_VALUE,
  convertedPromotedProductWebsitePixelPurchase:
    CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  convertedPromotedProductWebsitePixelPurchaseValue:
    CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  costPer15SecVideoView: COST_PER_15SEC_VIDEO_VIEW,
  costPer2SecContinuousVideoView: COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  costPerActionType: COST_PER_ACTION_TYPE,
  costPerAdClick: COST_PER_AD_CLICK,
  costPerDdaCountbyConvs: COST_PER_DDA_COUNT_BY_CONVS,
  costPerEstimatedAdRecallers: COST_PER_ESTIMATED_AD_RECALLERS,
  costPerInlineLinkClick: COST_PER_INLINE_LINK_CLICK,
  costPerInlinePostEngagement: COST_PER_INLINE_POST_ENGAGEMENT,
  costPerObjectiveResult: COST_PER_OBJECTIVE_RESULT,
  costPerOneThousandAdImpression: COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  costPerOutboundClick: COST_PER_OUTBOUND_CLICK,
  costPerResult: COST_PER_RESULT,
  costPerThruplay: COST_PER_THRUPLAY,
  costPerUniqueActionType: COST_PER_UNIQUE_ACTION_TYPE,
  costPerUniqueClick: COST_PER_UNIQUE_CLICK,
  costPerUniqueConversion: COST_PER_UNIQUE_CONVERSION,
  costPerUniqueInlineLinkClick: COST_PER_UNIQUE_INLINE_LINK_CLICK,
  costPerUniqueOutboundClick: COST_PER_UNIQUE_OUTBOUND_CLICK,
  costPer_15SecVideoView: COST_PER_15_SEC_VIDEO_VIEW,
  cpp: CPP,
  ddaCountbyConvs: DDA_COUNT_BY_CONVS,
  ddaResults: DDA_RESULTS,
  estimatedAdRecallers: ESTIMATED_AD_RECALLERS,
  instagramProfileFollow: INSTAGRAM_PROFILE_FOLLOW,
  fullViewImpressions: FULL_VIEW_IMPRESSIONS,
  fullViewReach: FULL_VIEW_REACH,
  inlineLinkClickCtr: INLINE_LINK_CLICK_CTR,
  inlineLinkClicks: INLINE_LINK_CLICKS,
  inlinePostEngagement: INLINE_POST_ENGAGEMENT,
  instantExperienceClicksToOpen: INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  instantExperienceClicksToStart: INSTANT_EXPERIENCE_CLICKS_TO_START,
  instantExperienceOutboundClicks: INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  interactiveComponentTap: INTERACTIVE_COMPONENT_TAP,
  landingPageViewPerLinkClick: LANDING_PAGE_VIEW_PER_LINK_CLICK,
  marketingMessagesDeliveryRate: MARKETING_MESSAGES_DELIVERY_RATE,
  objectiveResultRate: OBJECTIVE_RESULT_RATE,
  objectiveResults: OBJECTIVE_RESULTS,
  outboundClicks: OUTBOUND_CLICKS,
  outboundClicksCtr: OUTBOUND_CLICKS_CTR,
  purchasePerLandingPageView: PURCHASE_PER_LANDING_PAGE_VIEW,
  qualifyingQuestionQualifyAnswerRate: QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  resultRate: RESULT_RATE,
  results: RESULTS_METRICS,
  roas: ROAS_METRICS,
  shopsAssistedPurchases: SHOPS_ASSISTED_PURCHASES,
  socialSpend: SOCIAL_SPEND,
  totalCardView: TOTAL_CARD_VIEW,
  video30SecWatchedActions: VIDEO_30_SEC_WATCHED_ACTIONS,
  video_30SecWatchedActions: VIDEO_30_SEC_WATCHED_ACTIONS,
  videoAvgTimeWatchedActions: VIDEO_AVG_TIME_WATCHED_ACTIONS,
  videoContinuous2SecWatchedActions: VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  videoP100WatchedActions: VIDEO_P100_WATCHED_ACTIONS,
  videoP25WatchedActions: VIDEO_P25_WATCHED_ACTIONS,
  videoP50WatchedActions: VIDEO_P50_WATCHED_ACTIONS,
  videoP75WatchedActions: VIDEO_P75_WATCHED_ACTIONS,
  videoP95WatchedActions: VIDEO_P95_WATCHED_ACTIONS,
  videoPlayActions: VIDEO_PLAY_ACTIONS,
  videoPlayCurveActions: VIDEO_PLAY_CURVE_ACTIONS,
  videoPlayRetention0To15sActions: VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  videoPlayRetention20To60sActions: VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  videoHookRate: VIDEO_HOOK_RATE,
  videoRetentionRate: VIDEO_RETENTION_RATE,
  videoPlayRetentionGraphActions: VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  videoTimeWatchedActions: VIDEO_TIME_WATCHED_ACTIONS,
  websiteCtr: WEBSITE_CTR,
  websitePurchaseRoas: WEBSITE_PURCHASE_ROAS,

  // TikTok specific metrics
  billedCost: BILLED_COST,
  grossImpressions: GROSS_IMPRESSIONS,
  conversionRate: CONVERSION_RATE_TIKTOK,
  //resultRate: RESULT_RATE_TIKTOK,
  videoViewsP100: VIDEO_VIEWS_P100_TIKTOK,
  averageVideoPlay: AVERAGE_VIDEO_PLAY,
  engagementRate: ENGAGEMENT_RATE_TIKTOK,
  follows: FOLLOWS_LINKEDIN,
  likes: LIKES_LINKEDIN,
  comments: COMMENTS_LINKEDIN,
  shares: SHARES_LINKEDIN,
  profileVisits: PROFILE_VISITS_TIKTOK,
  liveViews: LIVE_VIEWS,
  appInstall: APP_INSTALL_TIKTOK,
  //costPerAppInstall: COST_PER_APP_INSTALL_TIKTOK,
  registration: REGISTRATION,
  costPerRegistration: COST_PER_REGISTRATION,
  purchase: PURCHASE_TIKTOK,
  //costPerPurchase: COST_PER_PURCHASE_TIKTOK,
  purchaseRate: PURCHASE_RATE,
  totalPurchaseValue: TOTAL_PURCHASE_VALUE,
  appEventAddToCart: APP_EVENT_ADD_TO_CART_TIKTOK,
  //costPerAppEventAddToCart: COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK,
  checkout: CHECKOUT_TIKTOK,
  //costPerCheckout: COST_PER_CHECKOUT_TIKTOK,
  viewContent: VIEW_CONTENT_TIKTOK,
  //costPerViewContent: COST_PER_VIEW_CONTENT_TIKTOK,
  nextDayOpen: NEXT_DAY_OPEN,
  day7Retention: DAY7_RETENTION,
  cashSpend: CASH_SPEND,
  voucherSpend: VOUCHER_SPEND,
  costPer1000Reached: COST_PER_1000_REACHED,
  conversionRateV2: CONVERSION_RATE_V2,
  realTimeConversion: REAL_TIME_CONVERSION,
  realTimeCostPerConversion: REAL_TIME_COST_PER_CONVERSION,
  realTimeConversionRate: REAL_TIME_CONVERSION_RATE,
  realTimeConversionRateV2: REAL_TIME_CONVERSION_RATE_V2,
  realTimeResult: REAL_TIME_RESULT,
  realTimeCostPerResult: REAL_TIME_COST_PER_RESULT,
  realTimeResultRate: REAL_TIME_RESULT_RATE,
  secondaryGoalResult: SECONDARY_GOAL_RESULT,
  costPerSecondaryGoalResult: COST_PER_SECONDARY_GOAL_RESULT,
  secondaryGoalResultRate: SECONDARY_GOAL_RESULT_RATE,
  //videoPlayActions: VIDEO_PLAY_ACTIONS_TIKTOK,
  videoWatched2s: VIDEO_WATCHED_2S,
  videoWatched6s: VIDEO_WATCHED_6S,
  videoViewsP25: VIDEO_VIEWS_P25,
  videoViewsP50: VIDEO_VIEWS_P50,
  videoViewsP75: VIDEO_VIEWS_P75,
  averageVideoPlayPerUser: AVERAGE_VIDEO_PLAY_PER_USER,
  paidEngagedView: PAID_ENGAGED_VIEW,
  paidEngagementEngagedView: PAID_ENGAGEMENT_ENGAGED_VIEW,
  engagedView15s: ENGAGED_VIEW_15S,
  paidEngagedView15s: PAID_ENGAGED_VIEW_15S,
  paidEngagementEngagedView15s: PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  clicksOnMusicDisc: CLICKS_ON_MUSIC_DISC,
  duetClicks: DUET_CLICKS,
  stitchClicks: STITCH_CLICKS,
  soundUsageClicks: SOUND_USAGE_CLICKS,
  anchorClicks: ANCHOR_CLICKS,
  anchorClickRate: ANCHOR_CLICK_RATE,
  clicksOnHashtagChallenge: CLICKS_ON_HASHTAG_CHALLENGE,
  profileVisitsRate: PROFILE_VISITS_RATE,
  ttPlaylistVisit: TT_PLAYLIST_VISIT,
  ttPlaylistVisitRate: TT_PLAYLIST_VISIT_RATE,
  liveUniqueViews: LIVE_UNIQUE_VIEWS,
  liveEffectiveViews: LIVE_EFFECTIVE_VIEWS,
  liveProductClicks: LIVE_PRODUCT_CLICKS,
  interactiveAddOnImpressions: INTERACTIVE_ADD_ON_IMPRESSIONS,
  interactiveAddOnDestinationClicks: INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  interactiveAddOnActivityClicks: INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  interactiveAddOnOptionAClicks: INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  interactiveAddOnOptionBClicks: INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  countdownStickerRecallClicks: COUNTDOWN_STICKER_RECALL_CLICKS,
  ixPageDurationAvg: IX_PAGE_DURATION_AVG,
  ixPageViewrateAvg: IX_PAGE_VIEWRATE_AVG,
  ixVideoViews: IX_VIDEO_VIEWS,
  ixVideoViewsP25: IX_VIDEO_VIEWS_P25,
  ixVideoViewsP50: IX_VIDEO_VIEWS_P50,
  ixVideoViewsP75: IX_VIDEO_VIEWS_P75,
  ixVideoViewsP100: IX_VIDEO_VIEWS_P100,
  ixAverageVideoPlay: IX_AVERAGE_VIDEO_PLAY,
  realTimeAppInstall: REAL_TIME_APP_INSTALL,
  realTimeAppInstallCost: REAL_TIME_APP_INSTALL_COST,
  registrationRate: REGISTRATION_RATE,
  totalRegistration: TOTAL_REGISTRATION,
  costPerTotalRegistration: COST_PER_TOTAL_REGISTRATION,
  totalPurchase: TOTAL_PURCHASE,
  costPerTotalPurchase: COST_PER_TOTAL_PURCHASE,
  valuePerTotalPurchase: VALUE_PER_TOTAL_PURCHASE,
  totalActivePayRoas: TOTAL_ACTIVE_PAY_ROAS,
  totalPurchaseRoasDay0: TOTAL_PURCHASE_ROAS_DAY0,
  totalPurchaseRoasDay2: TOTAL_PURCHASE_ROAS_DAY2,
  totalPurchaseRoasDay6: TOTAL_PURCHASE_ROAS_DAY6,
  totalPurchaseValueDay0: TOTAL_PURCHASE_VALUE_DAY0,
  totalPurchaseValueDay2: TOTAL_PURCHASE_VALUE_DAY2,
  totalPurchaseValueDay6: TOTAL_PURCHASE_VALUE_DAY6,
  appEventAddToCartRate: APP_EVENT_ADD_TO_CART_RATE,
  totalAppEventAddToCart: TOTAL_APP_EVENT_ADD_TO_CART,
  costPerTotalAppEventAddToCart: COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  valuePerTotalAppEventAddToCart: VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  totalAppEventAddToCartValue: TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  checkoutRate: CHECKOUT_RATE,
  totalCheckout: TOTAL_CHECKOUT,
  costPerTotalCheckout: COST_PER_TOTAL_CHECKOUT,
  valuePerCheckout: VALUE_PER_CHECKOUT,
  totalCheckoutValue: TOTAL_CHECKOUT_VALUE,
  viewContentRate: VIEW_CONTENT_RATE,
  totalViewContent: TOTAL_VIEW_CONTENT,
  costPerTotalViewContent: COST_PER_TOTAL_VIEW_CONTENT,
  valuePerTotalViewContent: VALUE_PER_TOTAL_VIEW_CONTENT,
  totalViewContentValue: TOTAL_VIEW_CONTENT_VALUE,
  costPerNextDayOpen: COST_PER_NEXT_DAY_OPEN,
  nextDayOpenRate: NEXT_DAY_OPEN_RATE,
  totalNextDayOpen: TOTAL_NEXT_DAY_OPEN,
  costPerTotalNextDayOpen: COST_PER_TOTAL_NEXT_DAY_OPEN,
  costPerDay7Retention: COST_PER_DAY7_RETENTION,
  day7RetentionRate: DAY7_RETENTION_RATE,
  totalDay7Retention: TOTAL_DAY7_RETENTION,
  costPerTotalDay7Retention: COST_PER_TOTAL_DAY7_RETENTION,
  valuePerTotalDay7Retention: VALUE_PER_TOTAL_DAY7_RETENTION,
  totalDay7RetentionValue: TOTAL_DAY7_RETENTION_VALUE,
  addPaymentInfo: ADD_PAYMENT_INFO,
  costPerAddPaymentInfo: COST_PER_ADD_PAYMENT_INFO,
  addPaymentInfoRate: ADD_PAYMENT_INFO_RATE,
  totalAddPaymentInfo: TOTAL_ADD_PAYMENT_INFO,
  costTotalAddPaymentInfo: COST_TOTAL_ADD_PAYMENT_INFO,
  addToWishlist: ADD_TO_WISHLIST,
  costPerAddToWishlist: COST_PER_ADD_TO_WISHLIST,
  addToWishlistRate: ADD_TO_WISHLIST_RATE,
  totalAddToWishlist: TOTAL_ADD_TO_WISHLIST,
  costPerTotalAddToWishlist: COST_PER_TOTAL_ADD_TO_WISHLIST,
  valuePerTotalAddToWishlist: VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  totalAddToWishlistValue: TOTAL_ADD_TO_WISHLIST_VALUE,
  launchApp: LAUNCH_APP,
  costPerLaunchApp: COST_PER_LAUNCH_APP,
  launchAppRate: LAUNCH_APP_RATE,
  totalLaunchApp: TOTAL_LAUNCH_APP,
  costPerTotalLaunchApp: COST_PER_TOTAL_LAUNCH_APP,
  completeTutorial: COMPLETE_TUTORIAL,
  costPerCompleteTutorial: COST_PER_COMPLETE_TUTORIAL,
  completeTutorialRate: COMPLETE_TUTORIAL_RATE,
  totalCompleteTutorial: TOTAL_COMPLETE_TUTORIAL,
  costPerTotalCompleteTutorial: COST_PER_TOTAL_COMPLETE_TUTORIAL,
  valuePerTotalCompleteTutorial: VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  totalCompleteTutorialValue: TOTAL_COMPLETE_TUTORIAL_VALUE,
  createGroup: CREATE_GROUP,
  costPerCreateGroup: COST_PER_CREATE_GROUP,
  createGroupRate: CREATE_GROUP_RATE,
  totalCreateGroup: TOTAL_CREATE_GROUP,
  costPerTotalCreateGroup: COST_PER_TOTAL_CREATE_GROUP,
  valuePerTotalCreateGroup: VALUE_PER_TOTAL_CREATE_GROUP,
  totalCreateGroupValue: TOTAL_CREATE_GROUP_VALUE,
  joinGroup: JOIN_GROUP,
  costPerJoinGroup: COST_PER_JOIN_GROUP,
  joinGroupRate: JOIN_GROUP_RATE,
  totalJoinGroup: TOTAL_JOIN_GROUP,
  costPerTotalJoinGroup: COST_PER_TOTAL_JOIN_GROUP,
  valuePerTotalJoinGroup: VALUE_PER_TOTAL_JOIN_GROUP,
  totalJoinGroupValue: TOTAL_JOIN_GROUP_VALUE,
  createGamerole: CREATE_GAMEROLE,
  costPerCreateGamerole: COST_PER_CREATE_GAMEROLE,
  createGameroleRate: CREATE_GAMEROLE_RATE,
  totalCreateGamerole: TOTAL_CREATE_GAMEROLE,
  costPerTotalCreateGamerole: COST_PER_TOTAL_CREATE_GAMEROLE,
  valuePerTotalCreateGamerole: VALUE_PER_TOTAL_CREATE_GAMEROLE,
  totalCreateGameroleValue: TOTAL_CREATE_GAMEROLE_VALUE,
  spendCredits: SPEND_CREDITS,
  costPerSpendCredits: COST_PER_SPEND_CREDITS,
  spendCreditsRate: SPEND_CREDITS_RATE,
  totalSpendCredits: TOTAL_SPEND_CREDITS,
  costPerTotalSpendCredits: COST_PER_TOTAL_SPEND_CREDITS,
  valuePerTotalSpendCredits: VALUE_PER_TOTAL_SPEND_CREDITS,
  totalSpendCreditsValue: TOTAL_SPEND_CREDITS_VALUE,
  achieveLevel: ACHIEVE_LEVEL,
  costPerAchieveLevel: COST_PER_ACHIEVE_LEVEL,
  achieveLevelRate: ACHIEVE_LEVEL_RATE,
  totalAchieveLevel: TOTAL_ACHIEVE_LEVEL,
  costPerTotalAchieveLevel: COST_PER_TOTAL_ACHIEVE_LEVEL,
  valuePerTotalAchieveLevel: VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  totalAchieveLevelValue: TOTAL_ACHIEVE_LEVEL_VALUE,
  unlockAchievement: UNLOCK_ACHIEVEMENT,
  costPerUnlockAchievement: COST_PER_UNLOCK_ACHIEVEMENT,
  unlockAchievementRate: UNLOCK_ACHIEVEMENT_RATE,
  totalUnlockAchievement: TOTAL_UNLOCK_ACHIEVEMENT,
  costPerTotalUnlockAchievement: COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  valuePerTotalUnlockAchievement: VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  totalUnlockAchievementValue: TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  salesLead: SALES_LEAD,
  costPerSalesLead: COST_PER_SALES_LEAD,
  salesLeadRate: SALES_LEAD_RATE,
  totalSalesLead: TOTAL_SALES_LEAD,
  costPerTotalSalesLead: COST_PER_TOTAL_SALES_LEAD,
  valuePerTotalSalesLead: VALUE_PER_TOTAL_SALES_LEAD,
  totalSalesLeadValue: TOTAL_SALES_LEAD_VALUE,
  inAppAdClick: IN_APP_AD_CLICK,
  costPerInAppAdClick: COST_PER_IN_APP_AD_CLICK,
  inAppAdClickRate: IN_APP_AD_CLICK_RATE,

  totalInAppAdClick: TOTAL_IN_APP_AD_CLICK,
  costPerTotalInAppAdClick: COST_PER_TOTAL_IN_APP_AD_CLICK,
  valuePerTotalInAppAdClick: VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  totalInAppAdClickValue: TOTAL_IN_APP_AD_CLICK_VALUE,
  inAppAdImpr: IN_APP_AD_IMPR,
  costPerInAppAdImpr: COST_PER_IN_APP_AD_IMPR,
  inAppAdImprRate: IN_APP_AD_IMPR_RATE,
  totalInAppAdImpr: TOTAL_IN_APP_AD_IMPR,
  costPerTotalInAppAdImpr: COST_PER_TOTAL_IN_APP_AD_IMPR,
  valuePerTotalInAppAdImpr: VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  totalInAppAdImprValue: TOTAL_IN_APP_AD_IMPR_VALUE,
  loanApply: LOAN_APPLY,
  costPerLoanApply: COST_PER_LOAN_APPLY,
  loanApplyRate: LOAN_APPLY_RATE,
  totalLoanApply: TOTAL_LOAN_APPLY,
  costPerTotalLoanApply: COST_PER_TOTAL_LOAN_APPLY,
  loanCredit: LOAN_CREDIT,
  costPerLoanCredit: COST_PER_LOAN_CREDIT,
  loanCreditRate: LOAN_CREDIT_RATE,
  totalLoanCredit: TOTAL_LOAN_CREDIT,
  costPerTotalLoanCredit: COST_PER_TOTAL_LOAN_CREDIT,
  loanDisbursement: LOAN_DISBURSEMENT,
  costPerLoanDisbursement: COST_PER_LOAN_DISBURSEMENT,
  loanDisbursementRate: LOAN_DISBURSEMENT_RATE,
  totalLoanDisbursement: TOTAL_LOAN_DISBURSEMENT,
  costPerTotalLoanDisbursement: COST_PER_TOTAL_LOAN_DISBURSEMENT,
  login: LOGIN,
  costPerLogin: COST_PER_LOGIN,
  loginRate: LOGIN_RATE,
  totalLogin: TOTAL_LOGIN,
  costPerTotalLogin: COST_PER_TOTAL_LOGIN,
  ratings: RATINGS,
  costPerRatings: COST_PER_RATINGS,
  ratingsRate: RATINGS_RATE,
  totalRatings: TOTAL_RATINGS,
  costPerTotalRatings: COST_PER_TOTAL_RATINGS,
  valuePerTotalRatings: VALUE_PER_TOTAL_RATINGS,
  totalRatingsValue: TOTAL_RATINGS_VALUE,
  search: SEARCH_TIKTOK,
  costPerSearch: COST_PER_SEARCH,
  searchRate: SEARCH_RATE,
  totalSearch: TOTAL_SEARCH,
  costPerTotalSearch: COST_PER_TOTAL_SEARCH,
  startTrial: START_TRIAL,
  costPerStartTrial: COST_PER_START_TRIAL,
  startTrialRate: START_TRIAL_RATE,
  totalStartTrial: TOTAL_START_TRIAL,
  costPerTotalStartTrial: COST_PER_TOTAL_START_TRIAL,
  subscribe: SUBSCRIBE,
  costPerSubscribe: COST_PER_SUBSCRIBE,
  subscribeRate: SUBSCRIBE_RATE,
  totalSubscribe: TOTAL_SUBSCRIBE,
  costPerTotalSubscribe: COST_PER_TOTAL_SUBSCRIBE,
  valuePerTotalSubscribe: VALUE_PER_TOTAL_SUBSCRIBE,
  totalSubscribeValue: TOTAL_SUBSCRIBE_VALUE,
  uniqueCustomAppEvents: UNIQUE_CUSTOM_APP_EVENTS,
  costPerUniqueCustomAppEvent: COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  customAppEventRate: CUSTOM_APP_EVENT_RATE,
  customAppEvents: CUSTOM_APP_EVENTS,
  costPerCustomAppEvent: COST_PER_CUSTOM_APP_EVENT,
  valuePerCustomAppEvent: VALUE_PER_CUSTOM_APP_EVENT,
  customAppEventsValue: CUSTOM_APP_EVENTS_VALUE,
  uniqueAdImpressionEvents: UNIQUE_AD_IMPRESSION_EVENTS,
  costPerUniqueAdImpressionEvent: COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  customizedAdImpressionEventRate: CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  adsImpressionEvents: ADS_IMPRESSION_EVENTS,
  costPreAdImpressionEvent: COST_PRE_AD_IMPRESSION_EVENT,
  valuePerAdImpressionEvent: VALUE_PER_AD_IMPRESSION_EVENT,
  totalAdImpressionEventsValue: TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  totalAdImpressionRoas: TOTAL_AD_IMPRESSION_ROAS,
  adImpressionAdRevenueRoasDay0: AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  adImpressionAdRevenueRoasDay2: AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  adImpressionAdRevenueRoasDay6: AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  adImpressionAdRevenueDay0: AD_IMPRESSION_AD_REVENUE_DAY0,
  adImpressionAdRevenueDay2: AD_IMPRESSION_AD_REVENUE_DAY2,
  adImpressionAdRevenueDay6: AD_IMPRESSION_AD_REVENUE_DAY6,
  completePaymentRoas: COMPLETE_PAYMENT_ROAS,
  completePayment: COMPLETE_PAYMENT,
  costPerCompletePayment: COST_PER_COMPLETE_PAYMENT,
  completePaymentRate: COMPLETE_PAYMENT_RATE,
  valuePerCompletePayment: VALUE_PER_COMPLETE_PAYMENT,
  totalCompletePaymentRate: TOTAL_COMPLETE_PAYMENT_RATE,
  totalLandingPageView: TOTAL_LANDING_PAGE_VIEW,
  costPerLandingPageView: COST_PER_LANDING_PAGE_VIEW,
  landingPageViewRate: LANDING_PAGE_VIEW_RATE,
  totalPageview: TOTAL_PAGEVIEW,
  costPerPageview: COST_PER_PAGEVIEW,
  pageviewRate: PAGEVIEW_RATE,
  avgValuePerPageview: AVG_VALUE_PER_PAGEVIEW,
  totalValuePerPageview: TOTAL_VALUE_PER_PAGEVIEW,
  pageBrowseView: PAGE_BROWSE_VIEW,
  costPerPageBrowseView: COST_PER_PAGE_BROWSE_VIEW,
  pageBrowseViewRate: PAGE_BROWSE_VIEW_RATE,
  totalPageBrowseViewValue: TOTAL_PAGE_BROWSE_VIEW_VALUE,
  valuePerPageBrowseView: VALUE_PER_PAGE_BROWSE_VIEW,
  buttonClick: BUTTON_CLICK,
  costPerButtonClick: COST_PER_BUTTON_CLICK,
  buttonClickRate: BUTTON_CLICK_RATE,
  valuePerButtonClick: VALUE_PER_BUTTON_CLICK,
  totalButtonClickValue: TOTAL_BUTTON_CLICK_VALUE,
  onlineConsult: ONLINE_CONSULT,
  costPerOnlineConsult: COST_PER_ONLINE_CONSULT,
  onlineConsultRate: ONLINE_CONSULT_RATE,
  valuePerOnlineConsult: VALUE_PER_ONLINE_CONSULT,
  totalOnlineConsultValue: TOTAL_ONLINE_CONSULT_VALUE,
  userRegistration: USER_REGISTRATION,
  costPerUserRegistration: COST_PER_USER_REGISTRATION,
  userRegistrationRate: USER_REGISTRATION_RATE,
  valuePerUserRegistration: VALUE_PER_USER_REGISTRATION,
  totalUserRegistrationValue: TOTAL_USER_REGISTRATION_VALUE,
  pageContentViewEvents: PAGE_CONTENT_VIEW_EVENTS,
  costPerPageContentViewEvent: COST_PER_PAGE_CONTENT_VIEW_EVENT,
  pageContentViewEventRate: PAGE_CONTENT_VIEW_EVENT_RATE,
  valuePerPageContentViewEvent: VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  totalPageViewContentEventsValue: TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  productDetailsPageBrowse: PRODUCT_DETAILS_PAGE_BROWSE,
  costPerProductDetailsPageBrowse: COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  productDetailsPageBrowseRate: PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  valuePerProductDetailsPageBrowse: VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  totalProductDetailsPageBrowseValue: TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  webEventAddToCart: WEB_EVENT_ADD_TO_CART,
  costPerWebEventAddToCart: COST_PER_WEB_EVENT_ADD_TO_CART,
  webEventAddToCartRate: WEB_EVENT_ADD_TO_CART_RATE,
  valuePerWebEventAddToCart: VALUE_PER_WEB_EVENT_ADD_TO_CART,
  totalWebEventAddToCartValue: TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  onWebOrder: ON_WEB_ORDER,
  costPerOnWebOrder: COST_PER_ON_WEB_ORDER,
  onWebOrderRate: ON_WEB_ORDER_RATE,
  valuePerOnWebOrder: VALUE_PER_ON_WEB_ORDER,
  totalOnWebOrderValue: TOTAL_ON_WEB_ORDER_VALUE,
  initiateCheckout: INITIATE_CHECKOUT,
  costPerInitiateCheckout: COST_PER_INITIATE_CHECKOUT,
  initiateCheckoutRate: INITIATE_CHECKOUT_RATE,
  valuePerInitiateCheckout: VALUE_PER_INITIATE_CHECKOUT,
  totalInitiateCheckoutValue: TOTAL_INITIATE_CHECKOUT_VALUE,
  addBilling: ADD_BILLING,
  costPerAddBilling: COST_PER_ADD_BILLING,
  addBillingRate: ADD_BILLING_RATE,
  valuePerAddBilling: VALUE_PER_ADD_BILLING,
  totalAddBillingValue: TOTAL_ADD_BILLING_VALUE,
  pageEventSearch: PAGE_EVENT_SEARCH,
  costPerPageEventSearch: COST_PER_PAGE_EVENT_SEARCH,
  pageEventSearchRate: PAGE_EVENT_SEARCH_RATE,
  valuePerPageEventSearch: VALUE_PER_PAGE_EVENT_SEARCH,
  totalPageEventSearchValue: TOTAL_PAGE_EVENT_SEARCH_VALUE,
  form: FORM_TIKTOK,
  costPerForm: COST_PER_FORM,
  formRate: FORM_RATE,
  valuePerForm: VALUE_PER_FORM,
  totalFormValue: TOTAL_FORM_VALUE,
  downloadStart: DOWNLOAD_START,
  costPerDownloadStart: COST_PER_DOWNLOAD_START,
  downloadStartRate: DOWNLOAD_START_RATE,
  valuePerDownloadStart: VALUE_PER_DOWNLOAD_START,
  totalDownloadStartValue: TOTAL_DOWNLOAD_START_VALUE,
  onWebAddToWishlist: ON_WEB_ADD_TO_WISHLIST,
  costPerOnWebAddToWishlist: COST_PER_ON_WEB_ADD_TO_WISHLIST,
  onWebAddToWishlistPerClick: ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  valuePerOnWebAddToWishlist: VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  totalOnWebAddToWishlistValue: TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  onWebSubscribe: ON_WEB_SUBSCRIBE,
  costPerOnWebSubscribe: COST_PER_ON_WEB_SUBSCRIBE,
  onWebSubscribePerClick: ON_WEB_SUBSCRIBE_PER_CLICK,
  valuePerOnWebSubscribe: VALUE_PER_ON_WEB_SUBSCRIBE,
  totalOnWebSubscribeValue: TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  websiteTotalFindLocation: WEBSITE_TOTAL_FIND_LOCATION,
  websiteCostPerFindLocation: WEBSITE_COST_PER_FIND_LOCATION,
  websiteFindLocationRate: WEBSITE_FIND_LOCATION_RATE,
  websiteValuePerFindLocation: WEBSITE_VALUE_PER_FIND_LOCATION,
  websiteTotalFindLocationValue: WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  websiteTotalSchedule: WEBSITE_TOTAL_SCHEDULE,
  websiteCostPerSchedule: WEBSITE_COST_PER_SCHEDULE,
  websiteScheduleRate: WEBSITE_SCHEDULE_RATE,
  websiteValuePerSchedule: WEBSITE_VALUE_PER_SCHEDULE,
  websiteTotalScheduleValue: WEBSITE_TOTAL_SCHEDULE_VALUE,
  websiteTotalCustomizeProduct: WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  websiteCostPerCustomizeProduct: WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  websiteCustomizeProductRate: WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  websiteValuePerCustomizeProduct: WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  websiteTotalCustomizeProductValue: WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  customPageEvents: CUSTOM_PAGE_EVENTS,
  costPerCustomPageEvent: COST_PER_CUSTOM_PAGE_EVENT,
  customPageEventRate: CUSTOM_PAGE_EVENT_RATE,
  valuePerCustomPageEvent: VALUE_PER_CUSTOM_PAGE_EVENT,
  customPageEventsValue: CUSTOM_PAGE_EVENTS_VALUE,
  onsitePurchasesRoas: ONSITE_PURCHASES_ROAS,
  onsiteTotalPurchase: ONSITE_TOTAL_PURCHASE,
  onsiteCostPerPurchase: ONSITE_COST_PER_PURCHASE,
  onsitePurchaseRate: ONSITE_PURCHASE_RATE,
  onsiteValuePerPurchase: ONSITE_VALUE_PER_PURCHASE,
  onsiteTotalPurchaseValue: ONSITE_TOTAL_PURCHASE_VALUE,
  onsiteTotalCheckoutInitiation: ONSITE_TOTAL_CHECKOUT_INITIATION,
  onsiteCostPerCheckoutInitiation: ONSITE_COST_PER_CHECKOUT_INITIATION,
  onsiteCheckoutInitiationRate: ONSITE_CHECKOUT_INITIATION_RATE,
  onsiteValuePerCheckoutInitiation: ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  onsiteTotalCheckoutInitiationValue: ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  onsiteTotalAddToCart: ONSITE_TOTAL_ADD_TO_CART,
  onsiteCostPerAddToCart: ONSITE_COST_PER_ADD_TO_CART,
  onsiteAddToCartRate: ONSITE_ADD_TO_CART_RATE,
  onsiteValuePerAddToCart: ONSITE_VALUE_PER_ADD_TO_CART,
  onsiteTotalAddToCartValue: ONSITE_TOTAL_ADD_TO_CART_VALUE,
  onsiteTotalProductDetailsPageView: ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  onsiteCostPerProductDetailsPageView:
    ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  onsiteProductDetailsPageViewRate: ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  onsiteValuePerProductDetailsPageView:
    ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  onsiteTotalProductDetailsPageViewValue:
    ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  onsiteAddToWishlist: ONSITE_ADD_TO_WISHLIST,
  costPerOnsiteAddToWishlist: COST_PER_ONSITE_ADD_TO_WISHLIST,
  onsiteAddToWishlistRate: ONSITE_ADD_TO_WISHLIST_RATE,
  valuePerOnsiteAddToWishlist: VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  totalOnsiteAddToWishlistValue: TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  onsiteAddBilling: ONSITE_ADD_BILLING,
  costPerOnsiteAddBilling: COST_PER_ONSITE_ADD_BILLING,
  onsiteAddBillingRate: ONSITE_ADD_BILLING_RATE,
  valuePerOnsiteAddBilling: VALUE_PER_ONSITE_ADD_BILLING,
  totalOnsiteAddBillingValue: TOTAL_ONSITE_ADD_BILLING_VALUE,
  onsiteForm: ONSITE_FORM,
  costPerOnsiteForm: COST_PER_ONSITE_FORM,
  onsiteFormRate: ONSITE_FORM_RATE,
  valuePerOnsiteForm: VALUE_PER_ONSITE_FORM,
  totalOnsiteFormValue: TOTAL_ONSITE_FORM_VALUE,
  onsiteTotalFilteredOutFormSubmission:
    ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  onsiteDownloadStart: ONSITE_DOWNLOAD_START,
  costPerOnsiteDownloadStart: COST_PER_ONSITE_DOWNLOAD_START,
  onsiteDownloadStartRate: ONSITE_DOWNLOAD_START_RATE,
  onsiteDestinationVisits: ONSITE_DESTINATION_VISITS,
  costPerOnsiteDestinationVisit: COST_PER_ONSITE_DESTINATION_VISIT,
  onsiteDestinationVisitRate: ONSITE_DESTINATION_VISIT_RATE,
  ixPageViewCount: IX_PAGE_VIEW_COUNT,
  costPerIxPageViewCount: COST_PER_IX_PAGE_VIEW_COUNT,
  ixPageViewCountRate: IX_PAGE_VIEW_COUNT_RATE,
  ixButtonClickCount: IX_BUTTON_CLICK_COUNT,
  costPerIxButtonClickCount: COST_PER_IX_BUTTON_CLICK_COUNT,
  ixButtonClickCountRate: IX_BUTTON_CLICK_COUNT_RATE,
  ixProductClickCount: IX_PRODUCT_CLICK_COUNT,
  costPerIxProductClickCount: COST_PER_IX_PRODUCT_CLICK_COUNT,
  ixProductClickCountRate: IX_PRODUCT_CLICK_COUNT_RATE,
  offlineTotalCrmEvents: OFFLINE_TOTAL_CRM_EVENTS,
  offlineCostPerCrmEvent: OFFLINE_COST_PER_CRM_EVENT,
  offlineCrmEventRate: OFFLINE_CRM_EVENT_RATE,
  offlineValuePerCrmEvent: OFFLINE_VALUE_PER_CRM_EVENT,
  offlineCrmEventValue: OFFLINE_CRM_EVENT_VALUE,
  offlineShoppingEvents: OFFLINE_SHOPPING_EVENTS,
  costPerOfflineShoppingEvent: COST_PER_OFFLINE_SHOPPING_EVENT,
  offlineShoppingEventRate: OFFLINE_SHOPPING_EVENT_RATE,
  valuePerOfflineShoppingEvent: VALUE_PER_OFFLINE_SHOPPING_EVENT,
  offlineShoppingEventsValue: OFFLINE_SHOPPING_EVENTS_VALUE,
  offlineShoppingEventsRoas: OFFLINE_SHOPPING_EVENTS_ROAS,
  offlineContactEvents: OFFLINE_CONTACT_EVENTS,
  costPerOfflineContactEvent: COST_PER_OFFLINE_CONTACT_EVENT,
  offlineContactEventRate: OFFLINE_CONTACT_EVENT_RATE,
  valuePerOfflineContactEvent: VALUE_PER_OFFLINE_CONTACT_EVENT,
  offlineContactEventsValue: OFFLINE_CONTACT_EVENTS_VALUE,
  offlineSubscribeEvents: OFFLINE_SUBSCRIBE_EVENTS,
  costPerOfflineSubscribeEvent: COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  offlineSubscribeEventRate: OFFLINE_SUBSCRIBE_EVENT_RATE,
  valuePerOfflineSubscribeEvent: VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  offlineSubscribeEventsValue: OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  offlineFormEvents: OFFLINE_FORM_EVENTS,
  costPerOfflineFormEvent: COST_PER_OFFLINE_FORM_EVENT,
  offlineFormEventRate: OFFLINE_FORM_EVENT_RATE,
  valuePerOfflineFormEvent: VALUE_PER_OFFLINE_FORM_EVENT,
  offlineFormEventsValue: OFFLINE_FORM_EVENTS_VALUE,
  offlineAddPaymentInfoEvents: OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  costPerOfflineAddPaymentInfoEvent: COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  offlineAddPaymentInfoEventRate: OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  valuePerOfflineAddPaymentInfoEvent: VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  offlineAddPaymentInfoEventsValue: OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  offlineAddToCartEvents: OFFLINE_ADD_TO_CART_EVENTS,
  costPerOfflineAddToCartEvent: COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  offlineAddToCartEventRate: OFFLINE_ADD_TO_CART_EVENT_RATE,
  valuePerOfflineAddToCartEvent: VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  offlineAddToCartEventsValue: OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  offlineAddToWishlistEvents: OFFLINE_ADD_TO_WISHLIST_EVENTS,
  costPerOfflineAddToWishlistEvent: COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  offlineAddToWishlistEventRate: OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  valuePerOfflineAddToWishlistEvent: VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  offlineAddToWishlistEventsValue: OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  offlineClickButtonEvents: OFFLINE_CLICK_BUTTON_EVENTS,
  costPerOfflineClickButtonEvent: COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  offlineClickButtonEventRate: OFFLINE_CLICK_BUTTON_EVENT_RATE,
  valuePerOfflineClickButtonEvent: VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  offlineClickButtonEventsValue: OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  offlineCompleteRegistrationEvents: OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  costPerOfflineCompleteRegistrationEvent:
    COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  offlineCompleteRegistrationEventRate:
    OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  valuePerOfflineCompleteRegistrationEvent:
    VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  offlineCompleteRegistrationEventsValue:
    OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  offlineDownloadEvents: OFFLINE_DOWNLOAD_EVENTS,
  costPerOfflineDownloadEvent: COST_PER_OFFLINE_DOWNLOAD_EVENT,
  offlineDownloadEventRate: OFFLINE_DOWNLOAD_EVENT_RATE,
  valuePerOfflineDownloadEvent: VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  offlineDownloadEventsValue: OFFLINE_DOWNLOAD_EVENTS_VALUE,
  offlineInitiateCheckoutEvents: OFFLINE_INITIATE_CHECKOUT_EVENTS,
  costPerOfflineInitiateCheckoutEvent: COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  offlineInitiateCheckoutEventRate: OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  valuePerOfflineInitiateCheckoutEvent:
    VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  offlineInitiateCheckoutEventsValue: OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  offlinePlaceOrderEvents: OFFLINE_PLACE_ORDER_EVENTS,
  costPerOfflinePlaceOrderEvent: COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  offlinePlaceOrderEventRate: OFFLINE_PLACE_ORDER_EVENT_RATE,
  valuePerOfflinePlaceOrderEvent: VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  offlinePlaceOrderEventsValue: OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  offlineSearchEvents: OFFLINE_SEARCH_EVENTS,
  costPerOfflineSearchEvent: COST_PER_OFFLINE_SEARCH_EVENT,
  offlineSearchEventRate: OFFLINE_SEARCH_EVENT_RATE,
  valuePerOfflineSearchEvent: VALUE_PER_OFFLINE_SEARCH_EVENT,
  offlineSearchEventsValue: OFFLINE_SEARCH_EVENTS_VALUE,
  offlineViewContentEvents: OFFLINE_VIEW_CONTENT_EVENTS,
  costPerOfflineViewContentEvent: COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  offlineViewContentEventRate: OFFLINE_VIEW_CONTENT_EVENT_RATE,
  valuePerOfflineViewContentEvent: VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  offlineViewContentEventsValue: OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  offlinePreferredLeads: OFFLINE_PREFERRED_LEADS,
  offlineCostPerPreferredLead: OFFLINE_COST_PER_PREFERRED_LEAD,
  offlinePreferredLeadRate: OFFLINE_PREFERRED_LEAD_RATE,
  offlineTotalFindLocation: OFFLINE_TOTAL_FIND_LOCATION,
  offlineCostPerFindLocation: OFFLINE_COST_PER_FIND_LOCATION,
  offlineFindLocationRate: OFFLINE_FIND_LOCATION_RATE,
  offlineValuePerFindLocation: OFFLINE_VALUE_PER_FIND_LOCATION,
  offlineTotalFindLocationValue: OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  offlineTotalSchedule: OFFLINE_TOTAL_SCHEDULE,
  offlineCostPerSchedule: OFFLINE_COST_PER_SCHEDULE,
  offlineScheduleRate: OFFLINE_SCHEDULE_RATE,
  offlineValuePerSchedule: OFFLINE_VALUE_PER_SCHEDULE,
  offlineTotalScheduleValue: OFFLINE_TOTAL_SCHEDULE_VALUE,
  offlineTotalCustomizeProduct: OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  offlineCostPerCustomizeProduct: OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  offlineCustomizeProductRate: OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  offlineValuePerCustomizeProduct: OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  offlineTotalCustomizeProductValue: OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  offlineTotalCustomEvents: OFFLINE_TOTAL_CUSTOM_EVENTS,
  offlineCostPerCustomEvent: OFFLINE_COST_PER_CUSTOM_EVENT,
  offlineCustomEventRate: OFFLINE_CUSTOM_EVENT_RATE,
  offlineValuePerCustomEvent: OFFLINE_VALUE_PER_CUSTOM_EVENT,
  offlineTotalCustomEventValue: OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  messagingTotalConversationTiktokDirectMessage:
    MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  messagingCostPerConversationTiktokDirectMessage:
    MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  messagingConversationRateTiktokDirectMessage:
    MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  messagingTotalConversationInstantMessagingApp:
    MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  messagingCostPerConversationInstantMessagingApp:
    MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  messagingConversationRateInstantMessagingApp:
    MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  onsiteShoppingRoas: ONSITE_SHOPPING_ROAS,
  onsiteShopping: ONSITE_SHOPPING,
  costPerOnsiteShopping: COST_PER_ONSITE_SHOPPING,
  onsiteShoppingRate: ONSITE_SHOPPING_RATE,
  valuePerOnsiteShopping: VALUE_PER_ONSITE_SHOPPING,
  totalOnsiteShoppingValue: TOTAL_ONSITE_SHOPPING_VALUE,
  shopTotalPurchaseByOrderSubmission: SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  shopGrossRevenueByOrderSubmission: SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  shopTotalItemsPurchased: SHOP_TOTAL_ITEMS_PURCHASED,
  onsiteInitiateCheckoutCount: ONSITE_INITIATE_CHECKOUT_COUNT,
  costPerOnsiteInitiateCheckoutCount: COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  onsiteInitiateCheckoutCountRate: ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  valuePerOnsiteInitiateCheckoutCount: VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  totalOnsiteInitiateCheckoutCountValue:
    TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  onsiteOnWebDetail: ONSITE_ON_WEB_DETAIL,
  costPerOnsiteOnWebDetail: COST_PER_ONSITE_ON_WEB_DETAIL,
  onsiteOnWebDetailRate: ONSITE_ON_WEB_DETAIL_RATE,
  valuePerOnsiteOnWebDetail: VALUE_PER_ONSITE_ON_WEB_DETAIL,
  totalOnsiteOnWebDetailValue: TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  onsiteOnWebCart: ONSITE_ON_WEB_CART,
  costPerOnsiteOnWebCart: COST_PER_ONSITE_ON_WEB_CART,
  onsiteOnWebCartRate: ONSITE_ON_WEB_CART_RATE,
  valuePerOnsiteOnWebCart: VALUE_PER_ONSITE_ON_WEB_CART,
  totalOnsiteOnWebCartValue: TOTAL_ONSITE_ON_WEB_CART_VALUE,
  vtaConversion: VTA_CONVERSION,
  costPerVtaConversion: COST_PER_VTA_CONVERSION,
  ctaConversion: CTA_CONVERSION,
  costPerCtaConversion: COST_PER_CTA_CONVERSION,
  engagedViewThroughConversions: ENGAGED_VIEW_THROUGH_CONVERSIONS,
  costPerEngagedViewThroughConversion: COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  vtaAppInstall: VTA_APP_INSTALL,
  costPerVtaAppInstall: COST_PER_VTA_APP_INSTALL,
  ctaAppInstall: CTA_APP_INSTALL,
  costPerCtaAppInstall: COST_PER_CTA_APP_INSTALL,
  evtaAppInstall: EVTA_APP_INSTALL,
  costPerEvtaAppInstall: COST_PER_EVTA_APP_INSTALL,
  vtaRegistration: VTA_REGISTRATION,
  costPerVtaRegistration: COST_PER_VTA_REGISTRATION,
  ctaRegistration: CTA_REGISTRATION,
  costPerCtaRegistration: COST_PER_CTA_REGISTRATION,
  evtaRegistration: EVTA_REGISTRATION,
  costPerEvtaRegistration: COST_PER_EVTA_REGISTRATION,
  vtaPurchase: VTA_PURCHASE,
  costPerVtaPurchase: COST_PER_VTA_PURCHASE,
  ctaPurchase: CTA_PURCHASE,
  costPerCtaPurchase: COST_PER_CTA_PURCHASE,
  evtaPurchase: EVTA_PURCHASE,
  costPerEvtaPurchase: COST_PER_EVTA_PURCHASE,
  vtaCompletePayment: VTA_COMPLETE_PAYMENT,
  costPerVtaPaymentsCompleted: COST_PER_VTA_PAYMENTS_COMPLETED,
  evtaPaymentsCompleted: EVTA_PAYMENTS_COMPLETED,
  costPerEvtaPaymentsCompleted: COST_PER_EVTA_PAYMENTS_COMPLETED,
  vtaCompletePaymentValue: VTA_COMPLETE_PAYMENT_VALUE,
  vtaCompletePaymentRoas: VTA_COMPLETE_PAYMENT_ROAS,

  skanResult: SKAN_RESULT,
  skanCostPerResult: SKAN_COST_PER_RESULT,
  skanResultRate: SKAN_RESULT_RATE,
  skanConversion: SKAN_CONVERSION,
  skanCostPerConversion: SKAN_COST_PER_CONVERSION,
  skanConversionRate: SKAN_CONVERSION_RATE,
  skanConversionRateV2: SKAN_CONVERSION_RATE_V2,
  skanClickTimeConversion: SKAN_CLICK_TIME_CONVERSION,
  skanClickTimeCostPerConversion: SKAN_CLICK_TIME_COST_PER_CONVERSION,
  skanClickTimeConversionRate: SKAN_CLICK_TIME_CONVERSION_RATE,
  skanClickTimeConversionRateV2: SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  skanAppInstall: SKAN_APP_INSTALL,
  skanCostPerAppInstall: SKAN_COST_PER_APP_INSTALL,
  skanAppInstallWithheld: SKAN_APP_INSTALL_WITHHELD,
  skanRegistration: SKAN_REGISTRATION,
  skanCostPerRegistration: SKAN_COST_PER_REGISTRATION,
  skanRegistrationRate: SKAN_REGISTRATION_RATE,
  skanTotalRegistration: SKAN_TOTAL_REGISTRATION,
  skanCostPerTotalRegistration: SKAN_COST_PER_TOTAL_REGISTRATION,
  skanPurchase: SKAN_PURCHASE,
  skanCostPerPurchase: SKAN_COST_PER_PURCHASE,
  skanPurchaseRate: SKAN_PURCHASE_RATE,
  skanTotalPurchase: SKAN_TOTAL_PURCHASE,
  skanCostPerTotalPurchase: SKAN_COST_PER_TOTAL_PURCHASE,
  skanTotalPurchaseValue: SKAN_TOTAL_PURCHASE_VALUE,
  skanTotalRepetitiveActivePayRoas: SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  skanAddToCart: SKAN_ADD_TO_CART,
  skanCostPerAddToCart: SKAN_COST_PER_ADD_TO_CART,
  skanAddToCartRate: SKAN_ADD_TO_CART_RATE,
  skanTotalAddToCart: SKAN_TOTAL_ADD_TO_CART,
  skanCostPerTotalAddToCart: SKAN_COST_PER_TOTAL_ADD_TO_CART,
  skanTotalAddToCartValue: SKAN_TOTAL_ADD_TO_CART_VALUE,
  skanCheckout: SKAN_CHECKOUT,
  skanCostPerCheckout: SKAN_COST_PER_CHECKOUT,
  skanCheckoutRate: SKAN_CHECKOUT_RATE,
  skanTotalCheckout: SKAN_TOTAL_CHECKOUT,
  skanCostPerTotalCheckout: SKAN_COST_PER_TOTAL_CHECKOUT,
  skanTotalCheckoutValue: SKAN_TOTAL_CHECKOUT_VALUE,
  skanViewContent: SKAN_VIEW_CONTENT,
  skanCostPerViewContent: SKAN_COST_PER_VIEW_CONTENT,
  skanViewContentRate: SKAN_VIEW_CONTENT_RATE,
  skanTotalViewContent: SKAN_TOTAL_VIEW_CONTENT,
  skanCostPerTotalViewContent: SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  skanTotalViewContentValue: SKAN_TOTAL_VIEW_CONTENT_VALUE,
  skanAddPaymentInfo: SKAN_ADD_PAYMENT_INFO,
  skanCostPerAddPaymentInfo: SKAN_COST_PER_ADD_PAYMENT_INFO,
  skanAddPaymentInfoRate: SKAN_ADD_PAYMENT_INFO_RATE,
  skanTotalAddPaymentInfo: SKAN_TOTAL_ADD_PAYMENT_INFO,
  skanCostTotalAddPaymentInfo: SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  skanAddToWishlist: SKAN_ADD_TO_WISHLIST,
  skanCostPerAddToWishlist: SKAN_COST_PER_ADD_TO_WISHLIST,
  skanAddToWishlistRate: SKAN_ADD_TO_WISHLIST_RATE,
  skanTotalAddToWishlist: SKAN_TOTAL_ADD_TO_WISHLIST,
  skanCostPerTotalAddToWishlist: SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  skanTotalAddToWishlistValue: SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  skanLaunchApp: SKAN_LAUNCH_APP,
  skanCostPerLaunchApp: SKAN_COST_PER_LAUNCH_APP,
  skanLaunchAppRate: SKAN_LAUNCH_APP_RATE,
  skanTotalLaunchApp: SKAN_TOTAL_LAUNCH_APP,
  skanCostPerTotalLaunchApp: SKAN_COST_PER_TOTAL_LAUNCH_APP,
  skanCompleteTutorial: SKAN_COMPLETE_TUTORIAL,
  skanCostPerCompleteTutorial: SKAN_COST_PER_COMPLETE_TUTORIAL,
  skanCompleteTutorialRate: SKAN_COMPLETE_TUTORIAL_RATE,
  skanTotalCompleteTutorial: SKAN_TOTAL_COMPLETE_TUTORIAL,
  skanCostPerTotalCompleteTutorial: SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  skanTotalCompleteTutorialValue: SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  skanCreateGroup: SKAN_CREATE_GROUP,
  skanCostPerCreateGroup: SKAN_COST_PER_CREATE_GROUP,
  skanCreateGroupRate: SKAN_CREATE_GROUP_RATE,
  skanTotalCreateGroup: SKAN_TOTAL_CREATE_GROUP,
  skanCostPerTotalCreateGroup: SKAN_COST_PER_TOTAL_CREATE_GROUP,
  skanTotalCreateGroupValue: SKAN_TOTAL_CREATE_GROUP_VALUE,
  skanJoinGroup: SKAN_JOIN_GROUP,
  skanCostPerJoinGroup: SKAN_COST_PER_JOIN_GROUP,
  skanJoinGroupRate: SKAN_JOIN_GROUP_RATE,
  skanTotalJoinGroup: SKAN_TOTAL_JOIN_GROUP,
  skanCostPerTotalJoinGroup: SKAN_COST_PER_TOTAL_JOIN_GROUP,
  skanTotalJoinGroupValue: SKAN_TOTAL_JOIN_GROUP_VALUE,
  skanCreateGamerole: SKAN_CREATE_GAMEROLE,
  skanCostPerCreateGamerole: SKAN_COST_PER_CREATE_GAMEROLE,
  skanCreateGameroleRate: SKAN_CREATE_GAMEROLE_RATE,
  skanTotalCreateGamerole: SKAN_TOTAL_CREATE_GAMEROLE,
  skanCostPerTotalCreateGamerole: SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  skanTotalCreateGameroleValue: SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  skanSpendCredits: SKAN_SPEND_CREDITS,
  skanCostPerSpendCredits: SKAN_COST_PER_SPEND_CREDITS,
  skanSpendCreditsRate: SKAN_SPEND_CREDITS_RATE,
  skanTotalSpendCredits: SKAN_TOTAL_SPEND_CREDITS,
  skanCostPerTotalSpendCredits: SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  skanTotalSpendCreditsValue: SKAN_TOTAL_SPEND_CREDITS_VALUE,
  skanAchieveLevel: SKAN_ACHIEVE_LEVEL,
  skanCostPerAchieveLevel: SKAN_COST_PER_ACHIEVE_LEVEL,
  skanAchieveLevelRate: SKAN_ACHIEVE_LEVEL_RATE,
  skanTotalAchieveLevel: SKAN_TOTAL_ACHIEVE_LEVEL,
  skanCostPerTotalAchieveLevel: SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  skanTotalAchieveLevelValue: SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  skanUnlockAchievement: SKAN_UNLOCK_ACHIEVEMENT,
  skanCostPerUnlockAchievement: SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  skanUnlockAchievementRate: SKAN_UNLOCK_ACHIEVEMENT_RATE,
  skanTotalUnlockAchievement: SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  skanCostPerTotalUnlockAchievement: SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  skanTotalUnlockAchievementValue: SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  skanSalesLead: SKAN_SALES_LEAD,
  skanCostPerSalesLead: SKAN_COST_PER_SALES_LEAD,
  skanSalesLeadRate: SKAN_SALES_LEAD_RATE,
  skanTotalSalesLead: SKAN_TOTAL_SALES_LEAD,
  skanCostPerTotalSalesLead: SKAN_COST_PER_TOTAL_SALES_LEAD,
  skanTotalSalesLeadValue: SKAN_TOTAL_SALES_LEAD_VALUE,
  skanInAppAdClick: SKAN_IN_APP_AD_CLICK,
  skanCostPerInAppAdClick: SKAN_COST_PER_IN_APP_AD_CLICK,
  skanInAppAdClickRate: SKAN_IN_APP_AD_CLICK_RATE,
  skanTotalInAppAdClick: SKAN_TOTAL_IN_APP_AD_CLICK,
  skanCostPerTotalInAppAdClick: SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  skanTotalInAppAdClickValue: SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  skanInAppAdImpr: SKAN_IN_APP_AD_IMPR,
  skanCostPerInAppAdImpr: SKAN_COST_PER_IN_APP_AD_IMPR,
  skanInAppAdImprRate: SKAN_IN_APP_AD_IMPR_RATE,
  skanTotalInAppAdImpr: SKAN_TOTAL_IN_APP_AD_IMPR,
  skanCostPerTotalInAppAdImpr: SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  skanTotalInAppAdImprValue: SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  skanLoanApply: SKAN_LOAN_APPLY,
  skanCostPerLoanApply: SKAN_COST_PER_LOAN_APPLY,
  skanLoanApplyRate: SKAN_LOAN_APPLY_RATE,
  skanTotalLoanApply: SKAN_TOTAL_LOAN_APPLY,
  skanCostPerTotalLoanApply: SKAN_COST_PER_TOTAL_LOAN_APPLY,
  skanLoanCredit: SKAN_LOAN_CREDIT,
  skanCostPerLoanCredit: SKAN_COST_PER_LOAN_CREDIT,
  skanLoanCreditRate: SKAN_LOAN_CREDIT_RATE,
  skanTotalLoanCredit: SKAN_TOTAL_LOAN_CREDIT,
  skanCostPerTotalLoanCredit: SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  skanLoanDisbursement: SKAN_LOAN_DISBURSEMENT,
  skanCostPerLoanDisbursement: SKAN_COST_PER_LOAN_DISBURSEMENT,
  skanLoanDisbursementRate: SKAN_LOAN_DISBURSEMENT_RATE,
  skanTotalLoanDisbursement: SKAN_TOTAL_LOAN_DISBURSEMENT,
  skanCostPerTotalLoanDisbursement: SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  skanLogin: SKAN_LOGIN,
  skanCostPerLogin: SKAN_COST_PER_LOGIN,
  skanLoginRate: SKAN_LOGIN_RATE,
  skanTotalLogin: SKAN_TOTAL_LOGIN,
  skanCostPerTotalLogin: SKAN_COST_PER_TOTAL_LOGIN,
  skanRatings: SKAN_RATINGS,
  skanCostPerRatings: SKAN_COST_PER_RATINGS,
  skanRatingsRate: SKAN_RATINGS_RATE,
  skanTotalRatings: SKAN_TOTAL_RATINGS,
  skanCostPerTotalRatings: SKAN_COST_PER_TOTAL_RATINGS,
  skanTotalRatingsValue: SKAN_TOTAL_RATINGS_VALUE,
  skanSearch: SKAN_SEARCH,
  skanCostPerSearch: SKAN_COST_PER_SEARCH,
  skanSearchRate: SKAN_SEARCH_RATE,
  skanTotalSearch: SKAN_TOTAL_SEARCH,
  skanCostPerTotalSearch: SKAN_COST_PER_TOTAL_SEARCH,
  skanStartTrial: SKAN_START_TRIAL,
  skanCostPerStartTrial: SKAN_COST_PER_START_TRIAL,
  skanStartTrialRate: SKAN_START_TRIAL_RATE,
  skanTotalStartTrial: SKAN_TOTAL_START_TRIAL,
  skanCostPerTotalStartTrial: SKAN_COST_PER_TOTAL_START_TRIAL,
  skanSubscribe: SKAN_SUBSCRIBE,
  skanCostPerSubscribe: SKAN_COST_PER_SUBSCRIBE,
  skanSubscribeRate: SKAN_SUBSCRIBE_RATE,
  skanTotalSubscribe: SKAN_TOTAL_SUBSCRIBE,
  skanCostPerTotalSubscribe: SKAN_COST_PER_TOTAL_SUBSCRIBE,
  skanTotalSubscribeValue: SKAN_TOTAL_SUBSCRIBE_VALUE,
  skanVtaConversion: SKAN_VTA_CONVERSION,
  skanCostPerVtaConversion: SKAN_COST_PER_VTA_CONVERSION,
  skanVtaAppInstall: SKAN_VTA_APP_INSTALL,
  skanCostPerVtaAppInstall: SKAN_COST_PER_VTA_APP_INSTALL,
  skanVtaRegistration: SKAN_VTA_REGISTRATION,
  skanCostPerVtaRegistration: SKAN_COST_PER_VTA_REGISTRATION,
  skanVtaPurchase: SKAN_VTA_PURCHASE,
  skanCostPerVtaPurchase: SKAN_COST_PER_VTA_PURCHASE,
  skanCtaConversion: SKAN_CTA_CONVERSION,
  skanCostPerCtaConversion: SKAN_COST_PER_CTA_CONVERSION,
  skanCtaAppInstall: SKAN_CTA_APP_INSTALL,
  skanCostPerCtaAppInstall: SKAN_COST_PER_CTA_APP_INSTALL,
  skanCtaRegistration: SKAN_CTA_REGISTRATION,
  skanCostPerCtaRegistration: SKAN_COST_PER_CTA_REGISTRATION,
  skanCtaPurchase: SKAN_CTA_PURCHASE,
  skanCostPerCtaPurchase: SKAN_COST_PER_CTA_PURCHASE,

  // LinkedIn specific metrics
  companyPageClicks: COMPANY_PAGE_CLICKS_LINKEDIN,
  externalWebsiteConversions: EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  fullScreenPlays: FULL_SCREEN_PLAYS_LINKEDIN,
  landingPageClicks: LANDING_PAGE_CLICKS_LINKEDIN,
  reactions: REACTIONS_LINKEDIN,
  totalEngagements: TOTAL_ENGAGEMENTS_LINKEDIN,
  videoCompletions: VIDEO_COMPLETIONS_LINKEDIN,
  videoStarts: VIDEO_STARTS_LINKEDIN,
  videoViews: VIDEO_VIEWS_LINKEDIN,
  oneClickLeadFormOpens: ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN,
  leadFormCompletionRate: LEAD_FORM_COMPLETION_RATE_LINKEDIN,
  validWorkEmailLeads: VALID_WORK_EMAIL_LEADS_LINKEDIN,
  downloadClicks: DOWNLOAD_CLICKS_LINKEDIN,
  documentFirstQuartileCompletions:
    DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN,
  documentMidpointCompletions: DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN,
  documentThirdQuartileCompletions:
    DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN,
  documentCompletions: DOCUMENT_COMPLETIONS_LINKEDIN,
};
